import { j as S, h as U, i as J, G as Pt, l as ce, U as be, m as Me, s as Fe, B as oe, t as _s, w as we } from "./UnstyledButton-ujNMaBde.js";
import { createContext as vs, useContext as gs, useCallback as Pe, createElement as lt, useRef as fe, useImperativeHandle as Ct, useEffect as ct, useState as Ae, forwardRef as bs } from "react";
import { M as Cs, B as Ms, e as Ls } from "./textarea-EfguEWJi.js";
import { g as Nt } from "./_commonjsHelpers-C6fGbg64.js";
import { b as ue, I as Ne, P as Ce, a as $t, g as Ss } from "./Button-CMUmoC07.js";
import { e as ks } from "./CloseButton-Bp_UJ8Gq.js";
import { A as Mt } from "./AccordionChevron-D-UrV_dq.js";
import { c as Ys } from "./clamp-CqQfNxSP.js";
import { I as Ot, u as ws } from "./TextInput-BwSh6Vl7.js";
import './dates.css';var $e = { exports: {} }, xs = $e.exports, Lt;
function Ps() {
  return Lt || (Lt = 1, (function(e, t) {
    (function(s, r) {
      e.exports = r();
    })(xs, (function() {
      var s = 1e3, r = 6e4, a = 36e5, n = "millisecond", p = "second", c = "minute", o = "hour", u = "day", d = "week", _ = "month", b = "quarter", C = "year", v = "date", R = "Invalid Date", j = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, F = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, N = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(g) {
        var f = ["th", "st", "nd", "rd"], l = g % 100;
        return "[" + g + (f[(l - 20) % 10] || f[l] || f[0]) + "]";
      } }, Y = function(g, f, l) {
        var h = String(g);
        return !h || h.length >= f ? g : "" + Array(f + 1 - h.length).join(l) + g;
      }, W = { s: Y, z: function(g) {
        var f = -g.utcOffset(), l = Math.abs(f), h = Math.floor(l / 60), i = l % 60;
        return (f <= 0 ? "+" : "-") + Y(h, 2, "0") + ":" + Y(i, 2, "0");
      }, m: function g(f, l) {
        if (f.date() < l.date()) return -g(l, f);
        var h = 12 * (l.year() - f.year()) + (l.month() - f.month()), i = f.clone().add(h, _), k = l - i < 0, D = f.clone().add(h + (k ? -1 : 1), _);
        return +(-(h + (l - i) / (k ? i - D : D - i)) || 0);
      }, a: function(g) {
        return g < 0 ? Math.ceil(g) || 0 : Math.floor(g);
      }, p: function(g) {
        return { M: _, y: C, w: d, d: u, D: v, h: o, m: c, s: p, ms: n, Q: b }[g] || String(g || "").toLowerCase().replace(/s$/, "");
      }, u: function(g) {
        return g === void 0;
      } }, m = "en", L = {};
      L[m] = N;
      var A = "$isDayjsObject", M = function(g) {
        return g instanceof I || !(!g || !g[A]);
      }, x = function g(f, l, h) {
        var i;
        if (!f) return m;
        if (typeof f == "string") {
          var k = f.toLowerCase();
          L[k] && (i = k), l && (L[k] = l, i = k);
          var D = f.split("-");
          if (!i && D.length > 1) return g(D[0]);
        } else {
          var P = f.name;
          L[P] = f, i = P;
        }
        return !h && i && (m = i), i || !h && m;
      }, O = function(g, f) {
        if (M(g)) return g.clone();
        var l = typeof f == "object" ? f : {};
        return l.date = g, l.args = arguments, new I(l);
      }, $ = W;
      $.l = x, $.i = M, $.w = function(g, f) {
        return O(g, { locale: f.$L, utc: f.$u, x: f.$x, $offset: f.$offset });
      };
      var I = (function() {
        function g(l) {
          this.$L = x(l.locale, null, !0), this.parse(l), this.$x = this.$x || l.x || {}, this[A] = !0;
        }
        var f = g.prototype;
        return f.parse = function(l) {
          this.$d = (function(h) {
            var i = h.date, k = h.utc;
            if (i === null) return /* @__PURE__ */ new Date(NaN);
            if ($.u(i)) return /* @__PURE__ */ new Date();
            if (i instanceof Date) return new Date(i);
            if (typeof i == "string" && !/Z$/i.test(i)) {
              var D = i.match(j);
              if (D) {
                var P = D[2] - 1 || 0, w = (D[7] || "0").substring(0, 3);
                return k ? new Date(Date.UTC(D[1], P, D[3] || 1, D[4] || 0, D[5] || 0, D[6] || 0, w)) : new Date(D[1], P, D[3] || 1, D[4] || 0, D[5] || 0, D[6] || 0, w);
              }
            }
            return new Date(i);
          })(l), this.init();
        }, f.init = function() {
          var l = this.$d;
          this.$y = l.getFullYear(), this.$M = l.getMonth(), this.$D = l.getDate(), this.$W = l.getDay(), this.$H = l.getHours(), this.$m = l.getMinutes(), this.$s = l.getSeconds(), this.$ms = l.getMilliseconds();
        }, f.$utils = function() {
          return $;
        }, f.isValid = function() {
          return this.$d.toString() !== R;
        }, f.isSame = function(l, h) {
          var i = O(l);
          return this.startOf(h) <= i && i <= this.endOf(h);
        }, f.isAfter = function(l, h) {
          return O(l) < this.startOf(h);
        }, f.isBefore = function(l, h) {
          return this.endOf(h) < O(l);
        }, f.$g = function(l, h, i) {
          return $.u(l) ? this[h] : this.set(i, l);
        }, f.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, f.valueOf = function() {
          return this.$d.getTime();
        }, f.startOf = function(l, h) {
          var i = this, k = !!$.u(h) || h, D = $.p(l), P = function(ee, z) {
            var X = $.w(i.$u ? Date.UTC(i.$y, z, ee) : new Date(i.$y, z, ee), i);
            return k ? X : X.endOf(u);
          }, w = function(ee, z) {
            return $.w(i.toDate()[ee].apply(i.toDate("s"), (k ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(z)), i);
          }, H = this.$W, T = this.$M, E = this.$D, K = "set" + (this.$u ? "UTC" : "");
          switch (D) {
            case C:
              return k ? P(1, 0) : P(31, 11);
            case _:
              return k ? P(1, T) : P(0, T + 1);
            case d:
              var Z = this.$locale().weekStart || 0, Q = (H < Z ? H + 7 : H) - Z;
              return P(k ? E - Q : E + (6 - Q), T);
            case u:
            case v:
              return w(K + "Hours", 0);
            case o:
              return w(K + "Minutes", 1);
            case c:
              return w(K + "Seconds", 2);
            case p:
              return w(K + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, f.endOf = function(l) {
          return this.startOf(l, !1);
        }, f.$set = function(l, h) {
          var i, k = $.p(l), D = "set" + (this.$u ? "UTC" : ""), P = (i = {}, i[u] = D + "Date", i[v] = D + "Date", i[_] = D + "Month", i[C] = D + "FullYear", i[o] = D + "Hours", i[c] = D + "Minutes", i[p] = D + "Seconds", i[n] = D + "Milliseconds", i)[k], w = k === u ? this.$D + (h - this.$W) : h;
          if (k === _ || k === C) {
            var H = this.clone().set(v, 1);
            H.$d[P](w), H.init(), this.$d = H.set(v, Math.min(this.$D, H.daysInMonth())).$d;
          } else P && this.$d[P](w);
          return this.init(), this;
        }, f.set = function(l, h) {
          return this.clone().$set(l, h);
        }, f.get = function(l) {
          return this[$.p(l)]();
        }, f.add = function(l, h) {
          var i, k = this;
          l = Number(l);
          var D = $.p(h), P = function(T) {
            var E = O(k);
            return $.w(E.date(E.date() + Math.round(T * l)), k);
          };
          if (D === _) return this.set(_, this.$M + l);
          if (D === C) return this.set(C, this.$y + l);
          if (D === u) return P(1);
          if (D === d) return P(7);
          var w = (i = {}, i[c] = r, i[o] = a, i[p] = s, i)[D] || 1, H = this.$d.getTime() + l * w;
          return $.w(H, this);
        }, f.subtract = function(l, h) {
          return this.add(-1 * l, h);
        }, f.format = function(l) {
          var h = this, i = this.$locale();
          if (!this.isValid()) return i.invalidDate || R;
          var k = l || "YYYY-MM-DDTHH:mm:ssZ", D = $.z(this), P = this.$H, w = this.$m, H = this.$M, T = i.weekdays, E = i.months, K = i.meridiem, Z = function(z, X, se, q) {
            return z && (z[X] || z(h, k)) || se[X].slice(0, q);
          }, Q = function(z) {
            return $.s(P % 12 || 12, z, "0");
          }, ee = K || function(z, X, se) {
            var q = z < 12 ? "AM" : "PM";
            return se ? q.toLowerCase() : q;
          };
          return k.replace(F, (function(z, X) {
            return X || (function(se) {
              switch (se) {
                case "YY":
                  return String(h.$y).slice(-2);
                case "YYYY":
                  return $.s(h.$y, 4, "0");
                case "M":
                  return H + 1;
                case "MM":
                  return $.s(H + 1, 2, "0");
                case "MMM":
                  return Z(i.monthsShort, H, E, 3);
                case "MMMM":
                  return Z(E, H);
                case "D":
                  return h.$D;
                case "DD":
                  return $.s(h.$D, 2, "0");
                case "d":
                  return String(h.$W);
                case "dd":
                  return Z(i.weekdaysMin, h.$W, T, 2);
                case "ddd":
                  return Z(i.weekdaysShort, h.$W, T, 3);
                case "dddd":
                  return T[h.$W];
                case "H":
                  return String(P);
                case "HH":
                  return $.s(P, 2, "0");
                case "h":
                  return Q(1);
                case "hh":
                  return Q(2);
                case "a":
                  return ee(P, w, !0);
                case "A":
                  return ee(P, w, !1);
                case "m":
                  return String(w);
                case "mm":
                  return $.s(w, 2, "0");
                case "s":
                  return String(h.$s);
                case "ss":
                  return $.s(h.$s, 2, "0");
                case "SSS":
                  return $.s(h.$ms, 3, "0");
                case "Z":
                  return D;
              }
              return null;
            })(z) || D.replace(":", "");
          }));
        }, f.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, f.diff = function(l, h, i) {
          var k, D = this, P = $.p(h), w = O(l), H = (w.utcOffset() - this.utcOffset()) * r, T = this - w, E = function() {
            return $.m(D, w);
          };
          switch (P) {
            case C:
              k = E() / 12;
              break;
            case _:
              k = E();
              break;
            case b:
              k = E() / 3;
              break;
            case d:
              k = (T - H) / 6048e5;
              break;
            case u:
              k = (T - H) / 864e5;
              break;
            case o:
              k = T / a;
              break;
            case c:
              k = T / r;
              break;
            case p:
              k = T / s;
              break;
            default:
              k = T;
          }
          return i ? k : $.a(k);
        }, f.daysInMonth = function() {
          return this.endOf(_).$D;
        }, f.$locale = function() {
          return L[this.$L];
        }, f.locale = function(l, h) {
          if (!l) return this.$L;
          var i = this.clone(), k = x(l, h, !0);
          return k && (i.$L = k), i;
        }, f.clone = function() {
          return $.w(this.$d, this);
        }, f.toDate = function() {
          return new Date(this.valueOf());
        }, f.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, f.toISOString = function() {
          return this.$d.toISOString();
        }, f.toString = function() {
          return this.$d.toUTCString();
        }, g;
      })(), B = I.prototype;
      return O.prototype = B, [["$ms", n], ["$s", p], ["$m", c], ["$H", o], ["$W", u], ["$M", _], ["$y", C], ["$D", v]].forEach((function(g) {
        B[g[1]] = function(f) {
          return this.$g(f, g[0], g[1]);
        };
      })), O.extend = function(g, f) {
        return g.$i || (g(f, I, O), g.$i = !0), O;
      }, O.locale = x, O.isDayjs = M, O.unix = function(g) {
        return O(1e3 * g);
      }, O.en = L[m], O.Ls = L, O.p = {}, O;
    }));
  })($e)), $e.exports;
}
var Ns = Ps();
const y = /* @__PURE__ */ Nt(Ns);
function $s({
  type: e,
  date: t,
  locale: s,
  format: r,
  labelSeparator: a
}) {
  const n = (p) => y(p).locale(s).format(r);
  return e === "default" ? t === null ? "" : n(t) : e === "multiple" ? t.map(n).join(", ") : e === "range" && Array.isArray(t) ? t[0] && t[1] ? `${n(t[0])} ${a} ${n(t[1])}` : t[0] ? `${n(t[0])} ${a} ` : "" : "";
}
function At({ formatter: e, ...t }) {
  return (e || $s)(t);
}
function Os({ direction: e, levelIndex: t, rowIndex: s, cellIndex: r, size: a }) {
  switch (e) {
    case "up":
      return t === 0 && s === 0 ? null : s === 0 ? {
        levelIndex: t - 1,
        rowIndex: r <= a[t - 1][a[t - 1].length - 1] - 1 ? a[t - 1].length - 1 : a[t - 1].length - 2,
        cellIndex: r
      } : {
        levelIndex: t,
        rowIndex: s - 1,
        cellIndex: r
      };
    case "down":
      return s === a[t].length - 1 ? {
        levelIndex: t + 1,
        rowIndex: 0,
        cellIndex: r
      } : s === a[t].length - 2 && r >= a[t][a[t].length - 1] ? {
        levelIndex: t + 1,
        rowIndex: 0,
        cellIndex: r
      } : {
        levelIndex: t,
        rowIndex: s + 1,
        cellIndex: r
      };
    case "left":
      return t === 0 && s === 0 && r === 0 ? null : s === 0 && r === 0 ? {
        levelIndex: t - 1,
        rowIndex: a[t - 1].length - 1,
        cellIndex: a[t - 1][a[t - 1].length - 1] - 1
      } : r === 0 ? {
        levelIndex: t,
        rowIndex: s - 1,
        cellIndex: a[t][s - 1] - 1
      } : {
        levelIndex: t,
        rowIndex: s,
        cellIndex: r - 1
      };
    case "right":
      return s === a[t].length - 1 && r === a[t][s] - 1 ? {
        levelIndex: t + 1,
        rowIndex: 0,
        cellIndex: 0
      } : r === a[t][s] - 1 ? {
        levelIndex: t,
        rowIndex: s + 1,
        cellIndex: 0
      } : {
        levelIndex: t,
        rowIndex: s,
        cellIndex: r + 1
      };
    default:
      return { levelIndex: t, rowIndex: s, cellIndex: r };
  }
}
function jt({
  controlsRef: e,
  direction: t,
  levelIndex: s,
  rowIndex: r,
  cellIndex: a,
  size: n
}) {
  const p = Os({ direction: t, size: n, rowIndex: r, cellIndex: a, levelIndex: s });
  if (!p)
    return;
  const c = e.current?.[p.levelIndex]?.[p.rowIndex]?.[p.cellIndex];
  c && (c.disabled || c.getAttribute("data-hidden") || c.getAttribute("data-outside") ? jt({
    controlsRef: e,
    direction: t,
    levelIndex: p.levelIndex,
    cellIndex: p.cellIndex,
    rowIndex: p.rowIndex,
    size: n
  }) : c.focus());
}
function As(e) {
  switch (e) {
    case "ArrowDown":
      return "down";
    case "ArrowUp":
      return "up";
    case "ArrowRight":
      return "right";
    case "ArrowLeft":
      return "left";
    default:
      return null;
  }
}
function js(e) {
  return e.current?.map((t) => t.map((s) => s.length));
}
function ut({
  controlsRef: e,
  levelIndex: t,
  rowIndex: s,
  cellIndex: r,
  event: a
}) {
  const n = As(a.key);
  if (n) {
    a.preventDefault();
    const p = js(e);
    jt({
      controlsRef: e,
      direction: n,
      levelIndex: t,
      rowIndex: s,
      cellIndex: r,
      size: p
    });
  }
}
function te(e) {
  return e == null || e === "" ? e : y(e).format("YYYY-MM-DD");
}
function Rt(e) {
  return e == null || e === "" ? e : y(e).format("YYYY-MM-DD HH:mm:ss");
}
function Ye({
  minDate: e,
  maxDate: t
}) {
  const s = y();
  return !e && !t ? te(s) : e && y(s).isBefore(e) ? te(e) : t && y(s).isAfter(t) ? te(t) : te(s);
}
const Ft = {
  locale: "en",
  firstDayOfWeek: 1,
  weekendDays: [0, 6],
  labelSeparator: "–",
  consistentWeeks: !1
}, Tt = vs(Ft);
function qr({ settings: e, children: t }) {
  return /* @__PURE__ */ S.jsx(Tt.Provider, { value: { ...Ft, ...e }, children: t });
}
function de() {
  const e = gs(Tt), t = Pe((n) => n || e.locale, [e.locale]), s = Pe(
    (n) => typeof n == "number" ? n : e.firstDayOfWeek,
    [e.firstDayOfWeek]
  ), r = Pe(
    (n) => Array.isArray(n) ? n : e.weekendDays,
    [e.weekendDays]
  ), a = Pe(
    (n) => typeof n == "string" ? n : e.labelSeparator,
    [e.labelSeparator]
  );
  return {
    ...e,
    getLocale: t,
    getFirstDayOfWeek: s,
    getWeekendDays: r,
    getLabelSeparator: a
  };
}
function Rs({ value: e, type: t, withTime: s }) {
  const r = s ? Rt : te;
  if (t === "range" && Array.isArray(e)) {
    const a = r(e[0]), n = r(e[1]);
    return a ? n ? `${a} – ${n}` : `${a} –` : "";
  }
  return t === "multiple" && Array.isArray(e) ? e.filter(Boolean).join(", ") : !Array.isArray(e) && e ? r(e) : "";
}
function Wt({
  value: e,
  type: t,
  name: s,
  form: r,
  withTime: a = !1
}) {
  return /* @__PURE__ */ S.jsx("input", { type: "hidden", value: Rs({ value: e, type: t, withTime: a }), name: s, form: r });
}
Wt.displayName = "@mantine/dates/HiddenDatesInput";
var Fs = { input: "m_468e7eda" };
const Ht = U((e, t) => {
  const s = J("TimeInput", null, e), {
    classNames: r,
    styles: a,
    unstyled: n,
    vars: p,
    withSeconds: c,
    minTime: o,
    maxTime: u,
    value: d,
    onChange: _,
    step: b,
    ...C
  } = s, { resolvedClassNames: v, resolvedStyles: R } = ue({
    classNames: r,
    styles: a,
    props: s
  }), j = (N) => {
    if (o !== void 0 || u !== void 0) {
      const [Y, W, m] = N.split(":").map(Number);
      if (o) {
        const [L, A, M] = o.split(":").map(Number);
        if (Y < L || Y === L && W < A || c && Y === L && W === A && m < M)
          return -1;
      }
      if (u) {
        const [L, A, M] = u.split(":").map(Number);
        if (Y > L || Y === L && W > A || c && Y === L && W === A && m > M)
          return 1;
      }
    }
    return 0;
  }, F = (N) => {
    if (s.onBlur?.(N), o !== void 0 || u !== void 0) {
      const Y = N.currentTarget.value;
      if (Y) {
        const W = j(Y);
        W === 1 ? (u && (N.currentTarget.value = u), s.onChange?.(N)) : W === -1 && (o && (N.currentTarget.value = o), s.onChange?.(N));
      }
    }
  };
  return /* @__PURE__ */ S.jsx(
    Ot,
    {
      classNames: { ...v, input: Pt(Fs.input, v?.input) },
      styles: R,
      unstyled: n,
      ref: t,
      value: d,
      step: b ?? (c ? 1 : 60),
      ...C,
      onChange: _,
      onBlur: F,
      type: "time",
      __staticSelector: "TimeInput"
    }
  );
});
Ht.classes = Ot.classes;
Ht.displayName = "@mantine/dates/TimeInput";
var It = { day: "m_396ce5cb" };
const Ts = Me((e, { size: t }) => ({
  day: {
    "--day-size": Fe(t, "day-size")
  }
})), dt = U((e, t) => {
  const s = J("Day", null, e), {
    classNames: r,
    className: a,
    style: n,
    styles: p,
    unstyled: c,
    vars: o,
    date: u,
    disabled: d,
    __staticSelector: _,
    weekend: b,
    outside: C,
    selected: v,
    renderDay: R,
    inRange: j,
    firstInRange: F,
    lastInRange: N,
    hidden: Y,
    static: W,
    highlightToday: m,
    attributes: L,
    ...A
  } = s, M = ce({
    name: _ || "Day",
    classes: It,
    props: s,
    className: a,
    style: n,
    classNames: r,
    styles: p,
    unstyled: c,
    attributes: L,
    vars: o,
    varsResolver: Ts,
    rootSelector: "day"
  });
  return /* @__PURE__ */ S.jsx(
    be,
    {
      ...M("day", { style: Y ? { display: "none" } : void 0 }),
      component: W ? "div" : "button",
      ref: t,
      disabled: d,
      "data-today": y(u).isSame(/* @__PURE__ */ new Date(), "day") || void 0,
      "data-hidden": Y || void 0,
      "data-highlight-today": m || void 0,
      "data-disabled": d || void 0,
      "data-weekend": !d && !C && b || void 0,
      "data-outside": !d && C || void 0,
      "data-selected": !d && v || void 0,
      "data-in-range": j && !d || void 0,
      "data-first-in-range": F && !d || void 0,
      "data-last-in-range": N && !d || void 0,
      "data-static": W || void 0,
      unstyled: c,
      ...A,
      children: R?.(u) || y(u).date()
    }
  );
});
dt.classes = It;
dt.displayName = "@mantine/dates/Day";
function Ws({
  locale: e,
  format: t = "dd",
  firstDayOfWeek: s = 1
}) {
  const r = y().day(s), a = [];
  for (let n = 0; n < 7; n += 1)
    typeof t == "string" ? a.push(y(r).add(n, "days").locale(e).format(t)) : a.push(t(y(r).add(n, "days").format("YYYY-MM-DD")));
  return a;
}
var Et = { weekday: "m_18a3eca" };
const Hs = Me((e, { size: t }) => ({
  weekdaysRow: {
    "--wr-fz": we(t),
    "--wr-spacing": _s(t)
  }
})), ft = U((e, t) => {
  const s = J("WeekdaysRow", null, e), {
    classNames: r,
    className: a,
    style: n,
    styles: p,
    unstyled: c,
    vars: o,
    locale: u,
    firstDayOfWeek: d,
    weekdayFormat: _,
    cellComponent: b = "th",
    __staticSelector: C,
    withWeekNumbers: v,
    attributes: R,
    ...j
  } = s, F = ce({
    name: C || "WeekdaysRow",
    classes: Et,
    props: s,
    className: a,
    style: n,
    classNames: r,
    styles: p,
    unstyled: c,
    attributes: R,
    vars: o,
    varsResolver: Hs,
    rootSelector: "weekdaysRow"
  }), N = de(), Y = Ws({
    locale: N.getLocale(u),
    format: _,
    firstDayOfWeek: N.getFirstDayOfWeek(d)
  }).map((W, m) => /* @__PURE__ */ S.jsx(b, { ...F("weekday"), children: W }, m));
  return /* @__PURE__ */ S.jsxs(oe, { component: "tr", ref: t, ...F("weekdaysRow"), ...j, children: [
    v && /* @__PURE__ */ S.jsx(b, { ...F("weekday"), children: "#" }),
    Y
  ] });
});
ft.classes = Et;
ft.displayName = "@mantine/dates/WeekdaysRow";
function Is(e, t = 1) {
  let s = y(e);
  if (!s.isValid())
    return s;
  const r = t === 0 ? 6 : t - 1;
  for (; s.day() !== r; )
    s = s.add(1, "day");
  return s.format("YYYY-MM-DD");
}
function Es(e, t = 1) {
  let s = y(e);
  for (; s.day() !== t; )
    s = s.subtract(1, "day");
  return s.format("YYYY-MM-DD");
}
function Bs({
  month: e,
  firstDayOfWeek: t = 1,
  consistentWeeks: s
}) {
  const r = y(e).subtract(y(e).date() - 1, "day"), a = y(r.format("YYYY-M-D")), n = a.format("YYYY-MM-DD"), p = a.add(+a.daysInMonth() - 1, "day").format("YYYY-MM-DD"), c = Is(p, t), o = [];
  let u = y(Es(n, t));
  for (; y(u).isBefore(c, "day"); ) {
    const d = [];
    for (let _ = 0; _ < 7; _ += 1)
      d.push(u.format("YYYY-MM-DD")), u = u.add(1, "day");
    o.push(d);
  }
  if (s && o.length < 6) {
    const d = o[o.length - 1], _ = d[d.length - 1];
    let b = y(_).add(1, "day");
    for (; o.length < 6; ) {
      const C = [];
      for (let v = 0; v < 7; v += 1)
        C.push(b.format("YYYY-MM-DD")), b = b.add(1, "day");
      o.push(C);
    }
  }
  return o;
}
function pt(e, t) {
  return y(e).format("YYYY-MM") === y(t).format("YYYY-MM");
}
function Bt(e, t) {
  return t ? y(e).isAfter(y(t).subtract(1, "day"), "day") : !0;
}
function zt(e, t) {
  return t ? y(e).isBefore(y(t).add(1, "day"), "day") : !0;
}
function zs({
  dates: e,
  minDate: t,
  maxDate: s,
  getDayProps: r,
  excludeDate: a,
  hideOutsideDates: n,
  month: p
}) {
  const c = e.flat().filter(
    (d) => zt(d, s) && Bt(d, t) && !a?.(d) && !r?.(d)?.disabled && (!n || pt(d, p))
  ), o = c.find((d) => r?.(d)?.selected);
  if (o)
    return o;
  const u = c.find((d) => y().isSame(d, "date"));
  return u || c[0];
}
var Oe = { exports: {} }, Vs = Oe.exports, St;
function Gs() {
  return St || (St = 1, (function(e, t) {
    (function(s, r) {
      e.exports = r();
    })(Vs, (function() {
      var s = "day";
      return function(r, a, n) {
        var p = function(u) {
          return u.add(4 - u.isoWeekday(), s);
        }, c = a.prototype;
        c.isoWeekYear = function() {
          return p(this).year();
        }, c.isoWeek = function(u) {
          if (!this.$utils().u(u)) return this.add(7 * (u - this.isoWeek()), s);
          var d, _, b, C, v = p(this), R = (d = this.isoWeekYear(), _ = this.$u, b = (_ ? n.utc : n)().year(d).startOf("year"), C = 4 - b.isoWeekday(), b.isoWeekday() > 4 && (C += 7), b.add(C, s));
          return v.diff(R, "week") + 1;
        }, c.isoWeekday = function(u) {
          return this.$utils().u(u) ? this.day() || 7 : this.day(this.day() % 7 ? u : u - 7);
        };
        var o = c.startOf;
        c.startOf = function(u, d) {
          var _ = this.$utils(), b = !!_.u(d) || d;
          return _.p(u) === "isoweek" ? b ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : o.bind(this)(u, d);
        };
      };
    }));
  })(Oe)), Oe.exports;
}
var Ks = Gs();
const qs = /* @__PURE__ */ Nt(Ks);
y.extend(qs);
function Us(e) {
  const t = e.find((s) => y(s).day() === 1);
  return y(t).isoWeek();
}
var Vt = { month: "m_cc9820d3", monthCell: "m_8f457cd5", weekNumber: "m_6cff9dea" };
const Js = {
  withCellSpacing: !0
}, Zs = Me((e, { size: t }) => ({
  weekNumber: {
    "--wn-fz": we(t),
    "--wn-size": Fe(t, "wn-size")
  }
})), Te = U((e, t) => {
  const s = J("Month", Js, e), {
    classNames: r,
    className: a,
    style: n,
    styles: p,
    unstyled: c,
    vars: o,
    __staticSelector: u,
    locale: d,
    firstDayOfWeek: _,
    weekdayFormat: b,
    month: C,
    weekendDays: v,
    getDayProps: R,
    excludeDate: j,
    minDate: F,
    maxDate: N,
    renderDay: Y,
    hideOutsideDates: W,
    hideWeekdays: m,
    getDayAriaLabel: L,
    static: A,
    __getDayRef: M,
    __onDayKeyDown: x,
    __onDayClick: O,
    __onDayMouseEnter: $,
    __preventFocus: I,
    __stopPropagation: B,
    withCellSpacing: g,
    size: f,
    highlightToday: l,
    withWeekNumbers: h,
    attributes: i,
    ...k
  } = s, D = ce({
    name: u || "Month",
    classes: Vt,
    props: s,
    className: a,
    style: n,
    classNames: r,
    styles: p,
    unstyled: c,
    attributes: i,
    vars: o,
    varsResolver: Zs,
    rootSelector: "month"
  }), P = de(), w = Bs({
    month: C,
    firstDayOfWeek: P.getFirstDayOfWeek(_),
    consistentWeeks: P.consistentWeeks
  }), H = zs({
    dates: w,
    minDate: te(F),
    maxDate: te(N),
    getDayProps: R,
    excludeDate: j,
    hideOutsideDates: W,
    month: C
  }), { resolvedClassNames: T, resolvedStyles: E } = ue({
    classNames: r,
    styles: p,
    props: s
  }), K = w.map((Z, Q) => {
    const ee = Z.map((z, X) => {
      const se = !pt(z, C), q = L?.(z) || y(z).locale(d || P.locale).format("D MMMM YYYY"), ae = R?.(z), ne = y(z).isSame(H, "date");
      return /* @__PURE__ */ S.jsx(
        "td",
        {
          ...D("monthCell"),
          "data-with-spacing": g || void 0,
          children: /* @__PURE__ */ S.jsx(
            dt,
            {
              __staticSelector: u || "Month",
              classNames: T,
              styles: E,
              unstyled: c,
              "data-mantine-stop-propagation": B || void 0,
              highlightToday: l,
              renderDay: Y,
              date: z,
              size: f,
              weekend: P.getWeekendDays(v).includes(y(z).get("day")),
              outside: se,
              hidden: W ? se : !1,
              "aria-label": q,
              static: A,
              disabled: j?.(z) || !zt(z, te(N)) || !Bt(z, te(F)),
              ref: (G) => {
                G && M?.(Q, X, G);
              },
              ...ae,
              onKeyDown: (G) => {
                ae?.onKeyDown?.(G), x?.(G, { rowIndex: Q, cellIndex: X, date: z });
              },
              onMouseEnter: (G) => {
                ae?.onMouseEnter?.(G), $?.(G, z);
              },
              onClick: (G) => {
                ae?.onClick?.(G), O?.(G, z);
              },
              onMouseDown: (G) => {
                ae?.onMouseDown?.(G), I && G.preventDefault();
              },
              tabIndex: I || !ne ? -1 : 0
            }
          )
        },
        z.toString()
      );
    });
    return /* @__PURE__ */ S.jsxs("tr", { ...D("monthRow"), children: [
      h && /* @__PURE__ */ S.jsx("td", { ...D("weekNumber"), children: Us(Z) }),
      ee
    ] }, Q);
  });
  return /* @__PURE__ */ S.jsxs(oe, { component: "table", ...D("month"), size: f, ref: t, ...k, children: [
    !m && /* @__PURE__ */ S.jsx("thead", { ...D("monthThead"), children: /* @__PURE__ */ S.jsx(
      ft,
      {
        __staticSelector: u || "Month",
        locale: d,
        firstDayOfWeek: _,
        weekdayFormat: b,
        size: f,
        classNames: T,
        styles: E,
        unstyled: c,
        withWeekNumbers: h
      }
    ) }),
    /* @__PURE__ */ S.jsx("tbody", { ...D("monthTbody"), children: K })
  ] });
});
Te.classes = Vt;
Te.displayName = "@mantine/dates/Month";
var Gt = { pickerControl: "m_dc6a3c71" };
const Qs = Me((e, { size: t }) => ({
  pickerControl: {
    "--dpc-fz": we(t),
    "--dpc-size": Fe(t, "dpc-size")
  }
})), We = U((e, t) => {
  const s = J("PickerControl", null, e), {
    classNames: r,
    className: a,
    style: n,
    styles: p,
    unstyled: c,
    vars: o,
    firstInRange: u,
    lastInRange: d,
    inRange: _,
    __staticSelector: b,
    selected: C,
    disabled: v,
    attributes: R,
    ...j
  } = s, F = ce({
    name: b || "PickerControl",
    classes: Gt,
    props: s,
    className: a,
    style: n,
    classNames: r,
    styles: p,
    unstyled: c,
    attributes: R,
    vars: o,
    varsResolver: Qs,
    rootSelector: "pickerControl"
  });
  return /* @__PURE__ */ S.jsx(
    be,
    {
      ...F("pickerControl"),
      ref: t,
      unstyled: c,
      "data-picker-control": !0,
      "data-selected": C && !v || void 0,
      "data-disabled": v || void 0,
      "data-in-range": _ && !v && !C || void 0,
      "data-first-in-range": u && !v || void 0,
      "data-last-in-range": d && !v || void 0,
      disabled: v,
      ...j
    }
  );
});
We.classes = Gt;
We.displayName = "@mantine/dates/PickerControl";
function Kt({ year: e, minDate: t, maxDate: s }) {
  return !t && !s ? !1 : !!(t && y(e).isBefore(t, "year") || s && y(e).isAfter(s, "year"));
}
function Xs({
  years: e,
  minDate: t,
  maxDate: s,
  getYearControlProps: r
}) {
  const a = e.flat().filter(
    (c) => !Kt({ year: c, minDate: t, maxDate: s }) && !r?.(c)?.disabled
  ), n = a.find((c) => r?.(c)?.selected);
  if (n)
    return n;
  const p = a.find((c) => y().isSame(c, "year"));
  return p || a[0];
}
function qt(e) {
  const t = y(e).year(), s = t - t % 10;
  let r = 0;
  const a = [[], [], [], []];
  for (let n = 0; n < 4; n += 1) {
    const p = n === 3 ? 1 : 3;
    for (let c = 0; c < p; c += 1)
      a[n].push(y(new Date(s + r, 0)).format("YYYY-MM-DD")), r += 1;
  }
  return a;
}
var Ut = { yearsList: "m_9206547b", yearsListCell: "m_c5a19c7d" };
const er = {
  yearsListFormat: "YYYY",
  withCellSpacing: !0
}, He = U((e, t) => {
  const s = J("YearsList", er, e), {
    classNames: r,
    className: a,
    style: n,
    styles: p,
    unstyled: c,
    vars: o,
    decade: u,
    yearsListFormat: d,
    locale: _,
    minDate: b,
    maxDate: C,
    getYearControlProps: v,
    __staticSelector: R,
    __getControlRef: j,
    __onControlKeyDown: F,
    __onControlClick: N,
    __onControlMouseEnter: Y,
    __preventFocus: W,
    __stopPropagation: m,
    withCellSpacing: L,
    size: A,
    attributes: M,
    ...x
  } = s, O = ce({
    name: R || "YearsList",
    classes: Ut,
    props: s,
    className: a,
    style: n,
    classNames: r,
    styles: p,
    unstyled: c,
    attributes: M,
    vars: o,
    rootSelector: "yearsList"
  }), $ = de(), I = qt(u), B = Xs({
    years: I,
    minDate: b,
    maxDate: C,
    getYearControlProps: v
  }), g = I.map((f, l) => {
    const h = f.map((i, k) => {
      const D = v?.(i), P = y(i).isSame(B, "year");
      return /* @__PURE__ */ S.jsx(
        "td",
        {
          ...O("yearsListCell"),
          "data-with-spacing": L || void 0,
          children: /* @__PURE__ */ S.jsx(
            We,
            {
              ...O("yearsListControl"),
              size: A,
              unstyled: c,
              "data-mantine-stop-propagation": m || void 0,
              disabled: Kt({ year: i, minDate: b, maxDate: C }),
              ref: (w) => {
                w && j?.(l, k, w);
              },
              ...D,
              onKeyDown: (w) => {
                D?.onKeyDown?.(w), F?.(w, { rowIndex: l, cellIndex: k, date: i });
              },
              onClick: (w) => {
                D?.onClick?.(w), N?.(w, i);
              },
              onMouseEnter: (w) => {
                D?.onMouseEnter?.(w), Y?.(w, i);
              },
              onMouseDown: (w) => {
                D?.onMouseDown?.(w), W && w.preventDefault();
              },
              tabIndex: W || !P ? -1 : 0,
              children: D?.children ?? y(i).locale($.getLocale(_)).format(d)
            }
          )
        },
        k
      );
    });
    return /* @__PURE__ */ S.jsx("tr", { ...O("yearsListRow"), children: h }, l);
  });
  return /* @__PURE__ */ S.jsx(oe, { component: "table", ref: t, size: A, ...O("yearsList"), ...x, children: /* @__PURE__ */ S.jsx("tbody", { children: g }) });
});
He.classes = Ut;
He.displayName = "@mantine/dates/YearsList";
function Jt({ month: e, minDate: t, maxDate: s }) {
  return !t && !s ? !1 : !!(t && y(e).isBefore(t, "month") || s && y(e).isAfter(s, "month"));
}
function tr({
  months: e,
  minDate: t,
  maxDate: s,
  getMonthControlProps: r
}) {
  const a = e.flat().filter(
    (c) => !Jt({ month: c, minDate: t, maxDate: s }) && !r?.(c)?.disabled
  ), n = a.find((c) => r?.(c)?.selected);
  if (n)
    return n;
  const p = a.find((c) => y().isSame(c, "month"));
  return p || a[0];
}
function sr(e) {
  const t = y(e).startOf("year").toDate(), s = [[], [], [], []];
  let r = 0;
  for (let a = 0; a < 4; a += 1)
    for (let n = 0; n < 3; n += 1)
      s[a].push(y(t).add(r, "months").format("YYYY-MM-DD")), r += 1;
  return s;
}
var Zt = { monthsList: "m_2a6c32d", monthsListCell: "m_fe27622f" };
const rr = {
  monthsListFormat: "MMM",
  withCellSpacing: !0
}, Ie = U((e, t) => {
  const s = J("MonthsList", rr, e), {
    classNames: r,
    className: a,
    style: n,
    styles: p,
    unstyled: c,
    vars: o,
    __staticSelector: u,
    year: d,
    monthsListFormat: _,
    locale: b,
    minDate: C,
    maxDate: v,
    getMonthControlProps: R,
    __getControlRef: j,
    __onControlKeyDown: F,
    __onControlClick: N,
    __onControlMouseEnter: Y,
    __preventFocus: W,
    __stopPropagation: m,
    withCellSpacing: L,
    size: A,
    attributes: M,
    ...x
  } = s, O = ce({
    name: u || "MonthsList",
    classes: Zt,
    props: s,
    className: a,
    style: n,
    classNames: r,
    styles: p,
    unstyled: c,
    attributes: M,
    vars: o,
    rootSelector: "monthsList"
  }), $ = de(), I = sr(d), B = tr({
    months: I,
    minDate: te(C),
    maxDate: te(v),
    getMonthControlProps: R
  }), g = I.map((f, l) => {
    const h = f.map((i, k) => {
      const D = R?.(i), P = y(i).isSame(B, "month");
      return /* @__PURE__ */ S.jsx(
        "td",
        {
          ...O("monthsListCell"),
          "data-with-spacing": L || void 0,
          children: /* @__PURE__ */ S.jsx(
            We,
            {
              ...O("monthsListControl"),
              size: A,
              unstyled: c,
              __staticSelector: u || "MonthsList",
              "data-mantine-stop-propagation": m || void 0,
              disabled: Jt({
                month: i,
                minDate: te(C),
                maxDate: te(v)
              }),
              ref: (w) => {
                w && j?.(l, k, w);
              },
              ...D,
              onKeyDown: (w) => {
                D?.onKeyDown?.(w), F?.(w, { rowIndex: l, cellIndex: k, date: i });
              },
              onClick: (w) => {
                D?.onClick?.(w), N?.(w, i);
              },
              onMouseEnter: (w) => {
                D?.onMouseEnter?.(w), Y?.(w, i);
              },
              onMouseDown: (w) => {
                D?.onMouseDown?.(w), W && w.preventDefault();
              },
              tabIndex: W || !P ? -1 : 0,
              children: D?.children ?? y(i).locale($.getLocale(b)).format(_)
            }
          )
        },
        k
      );
    });
    return /* @__PURE__ */ S.jsx("tr", { ...O("monthsListRow"), children: h }, l);
  });
  return /* @__PURE__ */ S.jsx(oe, { component: "table", ref: t, size: A, ...O("monthsList"), ...x, children: /* @__PURE__ */ S.jsx("tbody", { children: g }) });
});
Ie.classes = Zt;
Ie.displayName = "@mantine/dates/MonthsList";
var Qt = { calendarHeader: "m_730a79ed", calendarHeaderLevel: "m_f6645d97", calendarHeaderControl: "m_2351eeb0", calendarHeaderControlIcon: "m_367dc749" };
const ar = {
  hasNextLevel: !0,
  withNext: !0,
  withPrevious: !0,
  headerControlsOrder: ["previous", "level", "next"]
}, nr = Me((e, { size: t }) => ({
  calendarHeader: {
    "--dch-control-size": Fe(t, "dch-control-size"),
    "--dch-fz": we(t)
  }
})), pe = U((e, t) => {
  const s = J("CalendarHeader", ar, e), {
    classNames: r,
    className: a,
    style: n,
    styles: p,
    unstyled: c,
    vars: o,
    nextIcon: u,
    previousIcon: d,
    nextLabel: _,
    previousLabel: b,
    onNext: C,
    onPrevious: v,
    onLevelClick: R,
    label: j,
    nextDisabled: F,
    previousDisabled: N,
    hasNextLevel: Y,
    levelControlAriaLabel: W,
    withNext: m,
    withPrevious: L,
    headerControlsOrder: A,
    __staticSelector: M,
    __preventFocus: x,
    __stopPropagation: O,
    attributes: $,
    ...I
  } = s, B = ce({
    name: M || "CalendarHeader",
    classes: Qt,
    props: s,
    className: a,
    style: n,
    classNames: r,
    styles: p,
    unstyled: c,
    attributes: $,
    vars: o,
    varsResolver: nr,
    rootSelector: "calendarHeader"
  }), g = x ? (k) => k.preventDefault() : void 0, f = L && /* @__PURE__ */ lt(
    be,
    {
      ...B("calendarHeaderControl"),
      key: "previous",
      "data-direction": "previous",
      "aria-label": b,
      onClick: v,
      unstyled: c,
      onMouseDown: g,
      disabled: N,
      "data-disabled": N || void 0,
      tabIndex: x || N ? -1 : 0,
      "data-mantine-stop-propagation": O || void 0
    },
    d || /* @__PURE__ */ S.jsx(
      Mt,
      {
        ...B("calendarHeaderControlIcon"),
        "data-direction": "previous",
        size: "45%"
      }
    )
  ), l = /* @__PURE__ */ lt(
    be,
    {
      component: Y ? "button" : "div",
      ...B("calendarHeaderLevel"),
      key: "level",
      onClick: Y ? R : void 0,
      unstyled: c,
      onMouseDown: Y ? g : void 0,
      disabled: !Y,
      "data-static": !Y || void 0,
      "aria-label": W,
      tabIndex: x || !Y ? -1 : 0,
      "data-mantine-stop-propagation": O || void 0
    },
    j
  ), h = m && /* @__PURE__ */ lt(
    be,
    {
      ...B("calendarHeaderControl"),
      key: "next",
      "data-direction": "next",
      "aria-label": _,
      onClick: C,
      unstyled: c,
      onMouseDown: g,
      disabled: F,
      "data-disabled": F || void 0,
      tabIndex: x || F ? -1 : 0,
      "data-mantine-stop-propagation": O || void 0
    },
    u || /* @__PURE__ */ S.jsx(
      Mt,
      {
        ...B("calendarHeaderControlIcon"),
        "data-direction": "next",
        size: "45%"
      }
    )
  ), i = A.map((k) => k === "previous" ? f : k === "level" ? l : k === "next" ? h : null);
  return /* @__PURE__ */ S.jsx(oe, { ...B("calendarHeader"), ref: t, ...I, children: i });
});
pe.classes = Qt;
pe.displayName = "@mantine/dates/CalendarHeader";
function or(e) {
  const t = qt(e);
  return [t[0][0], t[3][0]];
}
const lr = {
  decadeLabelFormat: "YYYY"
}, Ee = U((e, t) => {
  const s = J("DecadeLevel", lr, e), {
    // YearsList settings
    decade: r,
    locale: a,
    minDate: n,
    maxDate: p,
    yearsListFormat: c,
    getYearControlProps: o,
    __getControlRef: u,
    __onControlKeyDown: d,
    __onControlClick: _,
    __onControlMouseEnter: b,
    withCellSpacing: C,
    // CalendarHeader settings
    __preventFocus: v,
    nextIcon: R,
    previousIcon: j,
    nextLabel: F,
    previousLabel: N,
    onNext: Y,
    onPrevious: W,
    nextDisabled: m,
    previousDisabled: L,
    levelControlAriaLabel: A,
    withNext: M,
    withPrevious: x,
    headerControlsOrder: O,
    // Other props
    decadeLabelFormat: $,
    classNames: I,
    styles: B,
    unstyled: g,
    __staticSelector: f,
    __stopPropagation: l,
    size: h,
    attributes: i,
    ...k
  } = s, D = de(), [P, w] = or(r), H = {
    __staticSelector: f || "DecadeLevel",
    classNames: I,
    styles: B,
    unstyled: g,
    size: h,
    attributes: i
  }, T = typeof m == "boolean" ? m : p ? !y(w).endOf("year").isBefore(p) : !1, E = typeof L == "boolean" ? L : n ? !y(P).startOf("year").isAfter(n) : !1, K = (Z, Q) => y(Z).locale(a || D.locale).format(Q);
  return /* @__PURE__ */ S.jsxs(oe, { "data-decade-level": !0, size: h, ref: t, ...k, children: [
    /* @__PURE__ */ S.jsx(
      pe,
      {
        label: typeof $ == "function" ? $(P, w) : `${K(P, $)} – ${K(
          w,
          $
        )}`,
        __preventFocus: v,
        __stopPropagation: l,
        nextIcon: R,
        previousIcon: j,
        nextLabel: F,
        previousLabel: N,
        onNext: Y,
        onPrevious: W,
        nextDisabled: T,
        previousDisabled: E,
        hasNextLevel: !1,
        levelControlAriaLabel: A,
        withNext: M,
        withPrevious: x,
        headerControlsOrder: O,
        ...H
      }
    ),
    /* @__PURE__ */ S.jsx(
      He,
      {
        decade: r,
        locale: a,
        minDate: n,
        maxDate: p,
        yearsListFormat: c,
        getYearControlProps: o,
        __getControlRef: u,
        __onControlKeyDown: d,
        __onControlClick: _,
        __onControlMouseEnter: b,
        __preventFocus: v,
        __stopPropagation: l,
        withCellSpacing: C,
        ...H
      }
    )
  ] });
});
Ee.classes = { ...He.classes, ...pe.classes };
Ee.displayName = "@mantine/dates/DecadeLevel";
const ir = {
  yearLabelFormat: "YYYY"
}, Be = U((e, t) => {
  const s = J("YearLevel", ir, e), {
    // MonthsList settings
    year: r,
    locale: a,
    minDate: n,
    maxDate: p,
    monthsListFormat: c,
    getMonthControlProps: o,
    __getControlRef: u,
    __onControlKeyDown: d,
    __onControlClick: _,
    __onControlMouseEnter: b,
    withCellSpacing: C,
    // CalendarHeader settings
    __preventFocus: v,
    nextIcon: R,
    previousIcon: j,
    nextLabel: F,
    previousLabel: N,
    onNext: Y,
    onPrevious: W,
    onLevelClick: m,
    nextDisabled: L,
    previousDisabled: A,
    hasNextLevel: M,
    levelControlAriaLabel: x,
    withNext: O,
    withPrevious: $,
    headerControlsOrder: I,
    // Other props
    yearLabelFormat: B,
    __staticSelector: g,
    __stopPropagation: f,
    size: l,
    classNames: h,
    styles: i,
    unstyled: k,
    attributes: D,
    ...P
  } = s, w = de(), H = {
    __staticSelector: g || "YearLevel",
    classNames: h,
    styles: i,
    unstyled: k,
    size: l,
    attributes: D
  }, T = typeof L == "boolean" ? L : p ? !y(r).endOf("year").isBefore(p) : !1, E = typeof A == "boolean" ? A : n ? !y(r).startOf("year").isAfter(n) : !1;
  return /* @__PURE__ */ S.jsxs(oe, { "data-year-level": !0, size: l, ref: t, ...P, children: [
    /* @__PURE__ */ S.jsx(
      pe,
      {
        label: typeof B == "function" ? B(r) : y(r).locale(a || w.locale).format(B),
        __preventFocus: v,
        __stopPropagation: f,
        nextIcon: R,
        previousIcon: j,
        nextLabel: F,
        previousLabel: N,
        onNext: Y,
        onPrevious: W,
        onLevelClick: m,
        nextDisabled: T,
        previousDisabled: E,
        hasNextLevel: M,
        levelControlAriaLabel: x,
        withNext: O,
        withPrevious: $,
        headerControlsOrder: I,
        ...H
      }
    ),
    /* @__PURE__ */ S.jsx(
      Ie,
      {
        year: r,
        locale: a,
        minDate: n,
        maxDate: p,
        monthsListFormat: c,
        getMonthControlProps: o,
        __getControlRef: u,
        __onControlKeyDown: d,
        __onControlClick: _,
        __onControlMouseEnter: b,
        __preventFocus: v,
        __stopPropagation: f,
        withCellSpacing: C,
        ...H
      }
    )
  ] });
});
Be.classes = { ...pe.classes, ...Ie.classes };
Be.displayName = "@mantine/dates/YearLevel";
const cr = {
  monthLabelFormat: "MMMM YYYY"
}, ze = U((e, t) => {
  const s = J("MonthLevel", cr, e), {
    // Month settings
    month: r,
    locale: a,
    firstDayOfWeek: n,
    weekdayFormat: p,
    weekendDays: c,
    getDayProps: o,
    excludeDate: u,
    minDate: d,
    maxDate: _,
    renderDay: b,
    hideOutsideDates: C,
    hideWeekdays: v,
    getDayAriaLabel: R,
    __getDayRef: j,
    __onDayKeyDown: F,
    __onDayClick: N,
    __onDayMouseEnter: Y,
    withCellSpacing: W,
    highlightToday: m,
    withWeekNumbers: L,
    // CalendarHeader settings
    __preventFocus: A,
    __stopPropagation: M,
    nextIcon: x,
    previousIcon: O,
    nextLabel: $,
    previousLabel: I,
    onNext: B,
    onPrevious: g,
    onLevelClick: f,
    nextDisabled: l,
    previousDisabled: h,
    hasNextLevel: i,
    levelControlAriaLabel: k,
    withNext: D,
    withPrevious: P,
    headerControlsOrder: w,
    // Other props
    monthLabelFormat: H,
    classNames: T,
    styles: E,
    unstyled: K,
    __staticSelector: Z,
    size: Q,
    static: ee,
    attributes: z,
    ...X
  } = s, se = de(), q = {
    __staticSelector: Z || "MonthLevel",
    classNames: T,
    styles: E,
    unstyled: K,
    size: Q,
    attributes: z
  }, ae = typeof l == "boolean" ? l : _ ? !y(r).endOf("month").isBefore(_) : !1, ne = typeof h == "boolean" ? h : d ? !y(r).startOf("month").isAfter(d) : !1;
  return /* @__PURE__ */ S.jsxs(oe, { "data-month-level": !0, size: Q, ref: t, ...X, children: [
    /* @__PURE__ */ S.jsx(
      pe,
      {
        label: typeof H == "function" ? H(r) : y(r).locale(a || se.locale).format(H),
        __preventFocus: A,
        __stopPropagation: M,
        nextIcon: x,
        previousIcon: O,
        nextLabel: $,
        previousLabel: I,
        onNext: B,
        onPrevious: g,
        onLevelClick: f,
        nextDisabled: ae,
        previousDisabled: ne,
        hasNextLevel: i,
        levelControlAriaLabel: k,
        withNext: D,
        withPrevious: P,
        headerControlsOrder: w,
        ...q
      }
    ),
    /* @__PURE__ */ S.jsx(
      Te,
      {
        month: r,
        locale: a,
        firstDayOfWeek: n,
        weekdayFormat: p,
        weekendDays: c,
        getDayProps: o,
        excludeDate: u,
        minDate: d,
        maxDate: _,
        renderDay: b,
        hideOutsideDates: C,
        hideWeekdays: v,
        getDayAriaLabel: R,
        __getDayRef: j,
        __onDayKeyDown: F,
        __onDayClick: N,
        __onDayMouseEnter: Y,
        __preventFocus: A,
        __stopPropagation: M,
        static: ee,
        withCellSpacing: W,
        highlightToday: m,
        withWeekNumbers: L,
        ...q
      }
    )
  ] });
});
ze.classes = { ...Te.classes, ...pe.classes };
ze.displayName = "@mantine/dates/MonthLevel";
var Xt = { levelsGroup: "m_30b26e33" };
const me = U((e, t) => {
  const s = J("LevelsGroup", null, e), {
    classNames: r,
    className: a,
    style: n,
    styles: p,
    unstyled: c,
    vars: o,
    __staticSelector: u,
    attributes: d,
    ..._
  } = s, b = ce({
    name: u || "LevelsGroup",
    classes: Xt,
    props: s,
    className: a,
    style: n,
    classNames: r,
    styles: p,
    unstyled: c,
    attributes: d,
    vars: o,
    rootSelector: "levelsGroup"
  });
  return /* @__PURE__ */ S.jsx(oe, { ref: t, ...b("levelsGroup"), ..._ });
});
me.classes = Xt;
me.displayName = "@mantine/dates/LevelsGroup";
const ur = {
  numberOfColumns: 1
}, Ve = U((e, t) => {
  const s = J("DecadeLevelGroup", ur, e), {
    // DecadeLevel settings
    decade: r,
    locale: a,
    minDate: n,
    maxDate: p,
    yearsListFormat: c,
    getYearControlProps: o,
    __onControlClick: u,
    __onControlMouseEnter: d,
    withCellSpacing: _,
    // CalendarHeader settings
    __preventFocus: b,
    nextIcon: C,
    previousIcon: v,
    nextLabel: R,
    previousLabel: j,
    onNext: F,
    onPrevious: N,
    nextDisabled: Y,
    previousDisabled: W,
    headerControlsOrder: m,
    // Other settings
    classNames: L,
    styles: A,
    unstyled: M,
    __staticSelector: x,
    __stopPropagation: O,
    numberOfColumns: $,
    levelControlAriaLabel: I,
    decadeLabelFormat: B,
    size: g,
    vars: f,
    attributes: l,
    ...h
  } = s, i = fe([]), k = Array($).fill(0).map((D, P) => {
    const w = y(r).add(P * 10, "years").format("YYYY-MM-DD");
    return /* @__PURE__ */ S.jsx(
      Ee,
      {
        size: g,
        yearsListFormat: c,
        decade: w,
        withNext: P === $ - 1,
        withPrevious: P === 0,
        decadeLabelFormat: B,
        __onControlClick: u,
        __onControlMouseEnter: d,
        __onControlKeyDown: (H, T) => ut({
          levelIndex: P,
          rowIndex: T.rowIndex,
          cellIndex: T.cellIndex,
          event: H,
          controlsRef: i
        }),
        __getControlRef: (H, T, E) => {
          Array.isArray(i.current[P]) || (i.current[P] = []), Array.isArray(i.current[P][H]) || (i.current[P][H] = []), i.current[P][H][T] = E;
        },
        levelControlAriaLabel: typeof I == "function" ? I(w) : I,
        locale: a,
        minDate: n,
        maxDate: p,
        __preventFocus: b,
        __stopPropagation: O,
        nextIcon: C,
        previousIcon: v,
        nextLabel: R,
        previousLabel: j,
        onNext: F,
        onPrevious: N,
        nextDisabled: Y,
        previousDisabled: W,
        getYearControlProps: o,
        __staticSelector: x || "DecadeLevelGroup",
        classNames: L,
        styles: A,
        unstyled: M,
        withCellSpacing: _,
        headerControlsOrder: m,
        attributes: l
      },
      P
    );
  });
  return /* @__PURE__ */ S.jsx(
    me,
    {
      classNames: L,
      styles: A,
      __staticSelector: x || "DecadeLevelGroup",
      ref: t,
      size: g,
      unstyled: M,
      attributes: l,
      ...h,
      children: k
    }
  );
});
Ve.classes = { ...me.classes, ...Ee.classes };
Ve.displayName = "@mantine/dates/DecadeLevelGroup";
const dr = {
  numberOfColumns: 1
}, Ge = U((e, t) => {
  const s = J("YearLevelGroup", dr, e), {
    // YearLevel settings
    year: r,
    locale: a,
    minDate: n,
    maxDate: p,
    monthsListFormat: c,
    getMonthControlProps: o,
    __onControlClick: u,
    __onControlMouseEnter: d,
    withCellSpacing: _,
    // CalendarHeader settings
    __preventFocus: b,
    nextIcon: C,
    previousIcon: v,
    nextLabel: R,
    previousLabel: j,
    onNext: F,
    onPrevious: N,
    onLevelClick: Y,
    nextDisabled: W,
    previousDisabled: m,
    hasNextLevel: L,
    headerControlsOrder: A,
    // Other settings
    classNames: M,
    styles: x,
    unstyled: O,
    __staticSelector: $,
    __stopPropagation: I,
    numberOfColumns: B,
    levelControlAriaLabel: g,
    yearLabelFormat: f,
    size: l,
    vars: h,
    attributes: i,
    ...k
  } = s, D = fe([]), P = Array(B).fill(0).map((w, H) => {
    const T = y(r).add(H, "years").format("YYYY-MM-DD");
    return /* @__PURE__ */ S.jsx(
      Be,
      {
        size: l,
        monthsListFormat: c,
        year: T,
        withNext: H === B - 1,
        withPrevious: H === 0,
        yearLabelFormat: f,
        __stopPropagation: I,
        __onControlClick: u,
        __onControlMouseEnter: d,
        __onControlKeyDown: (E, K) => ut({
          levelIndex: H,
          rowIndex: K.rowIndex,
          cellIndex: K.cellIndex,
          event: E,
          controlsRef: D
        }),
        __getControlRef: (E, K, Z) => {
          Array.isArray(D.current[H]) || (D.current[H] = []), Array.isArray(D.current[H][E]) || (D.current[H][E] = []), D.current[H][E][K] = Z;
        },
        levelControlAriaLabel: typeof g == "function" ? g(T) : g,
        locale: a,
        minDate: n,
        maxDate: p,
        __preventFocus: b,
        nextIcon: C,
        previousIcon: v,
        nextLabel: R,
        previousLabel: j,
        onNext: F,
        onPrevious: N,
        onLevelClick: Y,
        nextDisabled: W,
        previousDisabled: m,
        hasNextLevel: L,
        getMonthControlProps: o,
        classNames: M,
        styles: x,
        unstyled: O,
        __staticSelector: $ || "YearLevelGroup",
        withCellSpacing: _,
        headerControlsOrder: A,
        attributes: i
      },
      H
    );
  });
  return /* @__PURE__ */ S.jsx(
    me,
    {
      classNames: M,
      styles: x,
      __staticSelector: $ || "YearLevelGroup",
      ref: t,
      size: l,
      unstyled: O,
      attributes: i,
      ...k,
      children: P
    }
  );
});
Ge.classes = { ...Be.classes, ...me.classes };
Ge.displayName = "@mantine/dates/YearLevelGroup";
const fr = {
  numberOfColumns: 1
}, Ke = U((e, t) => {
  const s = J("MonthLevelGroup", fr, e), {
    // Month settings
    month: r,
    locale: a,
    firstDayOfWeek: n,
    weekdayFormat: p,
    weekendDays: c,
    getDayProps: o,
    excludeDate: u,
    minDate: d,
    maxDate: _,
    renderDay: b,
    hideOutsideDates: C,
    hideWeekdays: v,
    getDayAriaLabel: R,
    __onDayClick: j,
    __onDayMouseEnter: F,
    withCellSpacing: N,
    highlightToday: Y,
    withWeekNumbers: W,
    // CalendarHeader settings
    __preventFocus: m,
    nextIcon: L,
    previousIcon: A,
    nextLabel: M,
    previousLabel: x,
    onNext: O,
    onPrevious: $,
    onLevelClick: I,
    nextDisabled: B,
    previousDisabled: g,
    hasNextLevel: f,
    headerControlsOrder: l,
    // Other settings
    classNames: h,
    styles: i,
    unstyled: k,
    numberOfColumns: D,
    levelControlAriaLabel: P,
    monthLabelFormat: w,
    __staticSelector: H,
    __stopPropagation: T,
    size: E,
    static: K,
    vars: Z,
    attributes: Q,
    ...ee
  } = s, z = fe([]), X = Array(D).fill(0).map((se, q) => {
    const ae = y(r).add(q, "months").format("YYYY-MM-DD");
    return /* @__PURE__ */ S.jsx(
      ze,
      {
        month: ae,
        withNext: q === D - 1,
        withPrevious: q === 0,
        monthLabelFormat: w,
        __stopPropagation: T,
        __onDayClick: j,
        __onDayMouseEnter: F,
        __onDayKeyDown: (ne, G) => ut({
          levelIndex: q,
          rowIndex: G.rowIndex,
          cellIndex: G.cellIndex,
          event: ne,
          controlsRef: z
        }),
        __getDayRef: (ne, G, De) => {
          Array.isArray(z.current[q]) || (z.current[q] = []), Array.isArray(z.current[q][ne]) || (z.current[q][ne] = []), z.current[q][ne][G] = De;
        },
        levelControlAriaLabel: typeof P == "function" ? P(ae) : P,
        locale: a,
        firstDayOfWeek: n,
        weekdayFormat: p,
        weekendDays: c,
        getDayProps: o,
        excludeDate: u,
        minDate: d,
        maxDate: _,
        renderDay: b,
        hideOutsideDates: C,
        hideWeekdays: v,
        getDayAriaLabel: R,
        __preventFocus: m,
        nextIcon: L,
        previousIcon: A,
        nextLabel: M,
        previousLabel: x,
        onNext: O,
        onPrevious: $,
        onLevelClick: I,
        nextDisabled: B,
        previousDisabled: g,
        hasNextLevel: f,
        classNames: h,
        styles: i,
        unstyled: k,
        __staticSelector: H || "MonthLevelGroup",
        size: E,
        static: K,
        withCellSpacing: N,
        highlightToday: Y,
        withWeekNumbers: W,
        headerControlsOrder: l,
        attributes: Q
      },
      q
    );
  });
  return /* @__PURE__ */ S.jsx(
    me,
    {
      classNames: h,
      styles: i,
      __staticSelector: H || "MonthLevelGroup",
      ref: t,
      size: E,
      attributes: Q,
      ...ee,
      children: X
    }
  );
});
Ke.classes = { ...me.classes, ...ze.classes };
Ke.displayName = "@mantine/dates/MonthLevelGroup";
var es = { input: "m_6fa5e2aa" };
const he = U((e, t) => {
  const {
    inputProps: s,
    wrapperProps: r,
    placeholder: a,
    classNames: n,
    styles: p,
    unstyled: c,
    popoverProps: o,
    modalProps: u,
    dropdownType: d,
    children: _,
    formattedValue: b,
    dropdownHandlers: C,
    dropdownOpened: v,
    onClick: R,
    clearable: j,
    onClear: F,
    clearButtonProps: N,
    rightSection: Y,
    shouldClear: W,
    readOnly: m,
    disabled: L,
    value: A,
    name: M,
    form: x,
    type: O,
    onDropdownClose: $,
    withTime: I,
    ...B
  } = ws("PickerInputBase", { size: "sm" }, e), g = /* @__PURE__ */ S.jsx(Ne.ClearButton, { onClick: F, unstyled: c, ...N }), f = () => {
    O === "range" && Array.isArray(A) && A[0] && !A[1] && F(), C.close();
  };
  return /* @__PURE__ */ S.jsxs(S.Fragment, { children: [
    d === "modal" && !m && /* @__PURE__ */ S.jsx(
      Cs,
      {
        opened: v,
        onClose: f,
        withCloseButton: !1,
        size: "auto",
        "data-dates-modal": !0,
        unstyled: c,
        ...u,
        children: _
      }
    ),
    /* @__PURE__ */ S.jsx(Ne.Wrapper, { ...r, children: /* @__PURE__ */ S.jsxs(
      Ce,
      {
        position: "bottom-start",
        opened: v,
        trapFocus: !0,
        returnFocus: !1,
        unstyled: c,
        onClose: $,
        ...o,
        disabled: o?.disabled || d === "modal" || m,
        onChange: (l) => {
          l || (o?.onClose?.(), f());
        },
        children: [
          /* @__PURE__ */ S.jsx(Ce.Target, { children: /* @__PURE__ */ S.jsx(
            Ne,
            {
              "data-dates-input": !0,
              "data-read-only": m || void 0,
              disabled: L,
              component: "button",
              type: "button",
              multiline: !0,
              onClick: (l) => {
                R?.(l), C.toggle();
              },
              __clearSection: g,
              __clearable: j && W && !m && !L,
              rightSection: Y,
              ...s,
              ref: t,
              classNames: { ...n, input: Pt(es.input, n?.input) },
              ...B,
              children: b || /* @__PURE__ */ S.jsx(
                Ne.Placeholder,
                {
                  error: s.error,
                  unstyled: c,
                  classNames: n,
                  styles: p,
                  __staticSelector: s.__staticSelector,
                  children: a
                }
              )
            }
          ) }),
          /* @__PURE__ */ S.jsx(Ce.Dropdown, { "data-dates-dropdown": !0, children: _ })
        ]
      }
    ) }),
    /* @__PURE__ */ S.jsx(Wt, { value: A, name: M, form: x, type: O, withTime: I })
  ] });
});
he.classes = es;
he.displayName = "@mantine/dates/PickerInputBase";
const kt = (e) => e === "range" ? [null, null] : e === "multiple" ? [] : null, Yt = (e, t) => {
  const s = t ? Rt : te;
  return Array.isArray(e) ? e.map(s) : s(e);
};
function mt({
  type: e,
  value: t,
  defaultValue: s,
  onChange: r,
  withTime: a = !1
}) {
  const n = fe(e), [p, c, o] = $t({
    value: Yt(t, a),
    defaultValue: Yt(s, a),
    finalValue: kt(e),
    onChange: r
  });
  let u = p;
  return n.current !== e && (n.current = e, t === void 0 && (u = s !== void 0 ? s : kt(e), c(u))), [u, c, o];
}
function it(e, t) {
  return e ? e === "month" ? 0 : e === "year" ? 1 : 2 : t || 0;
}
function pr(e) {
  return e === 0 ? "month" : e === 1 ? "year" : "decade";
}
function ke(e, t, s) {
  return pr(
    Ys(
      it(e, 0),
      it(t, 0),
      it(s, 2)
    )
  );
}
const mr = {
  maxLevel: "decade",
  minLevel: "month",
  __updateDateOnYearSelect: !0,
  __updateDateOnMonthSelect: !0,
  enableKeyboardNavigation: !0
}, ye = U((e, t) => {
  const s = J("Calendar", mr, e), {
    // CalendarLevel props
    vars: r,
    maxLevel: a,
    minLevel: n,
    defaultLevel: p,
    level: c,
    onLevelChange: o,
    date: u,
    defaultDate: d,
    onDateChange: _,
    numberOfColumns: b,
    columnsToScroll: C,
    ariaLabels: v,
    nextLabel: R,
    previousLabel: j,
    onYearSelect: F,
    onMonthSelect: N,
    onYearMouseEnter: Y,
    onMonthMouseEnter: W,
    headerControlsOrder: m,
    __updateDateOnYearSelect: L,
    __updateDateOnMonthSelect: A,
    __setDateRef: M,
    __setLevelRef: x,
    // MonthLevelGroup props
    firstDayOfWeek: O,
    weekdayFormat: $,
    weekendDays: I,
    getDayProps: B,
    excludeDate: g,
    renderDay: f,
    hideOutsideDates: l,
    hideWeekdays: h,
    getDayAriaLabel: i,
    monthLabelFormat: k,
    nextIcon: D,
    previousIcon: P,
    __onDayClick: w,
    __onDayMouseEnter: H,
    withCellSpacing: T,
    highlightToday: E,
    withWeekNumbers: K,
    // YearLevelGroup props
    monthsListFormat: Z,
    getMonthControlProps: Q,
    yearLabelFormat: ee,
    // DecadeLevelGroup props
    yearsListFormat: z,
    getYearControlProps: X,
    decadeLabelFormat: se,
    // Other props
    classNames: q,
    styles: ae,
    unstyled: ne,
    minDate: G,
    maxDate: De,
    locale: Le,
    __staticSelector: Qe,
    size: Dt,
    __preventFocus: Xe,
    __stopPropagation: et,
    onNextDecade: rs,
    onPreviousDecade: as,
    onNextYear: ns,
    onPreviousYear: os,
    onNextMonth: ls,
    onPreviousMonth: is,
    static: tt,
    enableKeyboardNavigation: _t,
    attributes: cs,
    ...us
  } = s, { resolvedClassNames: ds, resolvedStyles: fs } = ue({
    classNames: q,
    styles: ae,
    props: s
  }), [Se, ve] = $t({
    value: c ? ke(c, n, a) : void 0,
    defaultValue: p ? ke(p, n, a) : void 0,
    finalValue: ke(void 0, n, a),
    onChange: o
  }), [ps, le] = mt({
    type: "default",
    value: te(u),
    defaultValue: te(d),
    onChange: _
  });
  Ct(M, () => (V) => {
    le(V);
  }), Ct(x, () => (V) => {
    ve(V);
  });
  const st = {
    __staticSelector: Qe || "Calendar",
    styles: fs,
    classNames: ds,
    unstyled: ne,
    size: Dt,
    attributes: cs
  }, ge = C || b || 1, vt = /* @__PURE__ */ new Date(), ms = G && y(vt).isAfter(G) ? G : y(vt).format("YYYY-MM-DD"), ie = ps || ms, hs = () => {
    const V = y(ie).add(ge, "month").format("YYYY-MM-DD");
    ls?.(V), le(V);
  }, ys = () => {
    const V = y(ie).subtract(ge, "month").format("YYYY-MM-DD");
    is?.(V), le(V);
  }, rt = () => {
    const V = y(ie).add(ge, "year").format("YYYY-MM-DD");
    ns?.(V), le(V);
  }, at = () => {
    const V = y(ie).subtract(ge, "year").format("YYYY-MM-DD");
    os?.(V), le(V);
  }, nt = () => {
    const V = y(ie).add(10 * ge, "year").format("YYYY-MM-DD");
    rs?.(V), le(V);
  }, ot = () => {
    const V = y(ie).subtract(10 * ge, "year").format("YYYY-MM-DD");
    as?.(V), le(V);
  }, gt = fe(null);
  ct(() => {
    if (!_t || tt)
      return;
    const V = (re) => {
      if (!gt.current?.contains(document.activeElement))
        return;
      const xe = re.ctrlKey || re.metaKey, bt = re.shiftKey;
      switch (re.key) {
        case "ArrowUp":
          xe && bt ? (re.preventDefault(), ot()) : xe && (re.preventDefault(), at());
          break;
        case "ArrowDown":
          xe && bt ? (re.preventDefault(), nt()) : xe && (re.preventDefault(), rt());
          break;
        case "y":
        case "Y":
          Se === "month" && (re.preventDefault(), ve("year"));
          break;
      }
    };
    return document.addEventListener("keydown", V), () => {
      document.removeEventListener("keydown", V);
    };
  }, [
    _t,
    tt,
    Se,
    rt,
    at,
    nt,
    ot
  ]);
  const Ds = (V) => {
    gt.current = V, typeof t == "function" ? t(V) : t && (t.current = V);
  };
  return /* @__PURE__ */ S.jsxs(oe, { ref: Ds, size: Dt, "data-calendar": !0, ...us, children: [
    Se === "month" && /* @__PURE__ */ S.jsx(
      Ke,
      {
        month: ie,
        minDate: G,
        maxDate: De,
        firstDayOfWeek: O,
        weekdayFormat: $,
        weekendDays: I,
        getDayProps: B,
        excludeDate: g,
        renderDay: f,
        hideOutsideDates: l,
        hideWeekdays: h,
        getDayAriaLabel: i,
        onNext: hs,
        onPrevious: ys,
        hasNextLevel: a !== "month",
        onLevelClick: () => ve("year"),
        numberOfColumns: b,
        locale: Le,
        levelControlAriaLabel: v?.monthLevelControl,
        nextLabel: v?.nextMonth ?? R,
        nextIcon: D,
        previousLabel: v?.previousMonth ?? j,
        previousIcon: P,
        monthLabelFormat: k,
        __onDayClick: w,
        __onDayMouseEnter: H,
        __preventFocus: Xe,
        __stopPropagation: et,
        static: tt,
        withCellSpacing: T,
        highlightToday: E,
        withWeekNumbers: K,
        headerControlsOrder: m,
        ...st
      }
    ),
    Se === "year" && /* @__PURE__ */ S.jsx(
      Ge,
      {
        year: ie,
        numberOfColumns: b,
        minDate: G,
        maxDate: De,
        monthsListFormat: Z,
        getMonthControlProps: Q,
        locale: Le,
        onNext: rt,
        onPrevious: at,
        hasNextLevel: a !== "month" && a !== "year",
        onLevelClick: () => ve("decade"),
        levelControlAriaLabel: v?.yearLevelControl,
        nextLabel: v?.nextYear ?? R,
        nextIcon: D,
        previousLabel: v?.previousYear ?? j,
        previousIcon: P,
        yearLabelFormat: ee,
        __onControlMouseEnter: W,
        __onControlClick: (V, re) => {
          A && le(re), ve(ke("month", n, a)), N?.(re);
        },
        __preventFocus: Xe,
        __stopPropagation: et,
        withCellSpacing: T,
        headerControlsOrder: m,
        ...st
      }
    ),
    Se === "decade" && /* @__PURE__ */ S.jsx(
      Ve,
      {
        decade: ie,
        minDate: G,
        maxDate: De,
        yearsListFormat: z,
        getYearControlProps: X,
        locale: Le,
        onNext: nt,
        onPrevious: ot,
        numberOfColumns: b,
        nextLabel: v?.nextDecade ?? R,
        nextIcon: D,
        previousLabel: v?.previousDecade ?? j,
        previousIcon: P,
        decadeLabelFormat: se,
        __onControlMouseEnter: Y,
        __onControlClick: (V, re) => {
          L && le(re), ve(ke("year", n, a)), F?.(re);
        },
        __preventFocus: Xe,
        __stopPropagation: et,
        withCellSpacing: T,
        headerControlsOrder: m,
        ...st
      }
    )
  ] });
});
ye.classes = {
  ...Ve.classes,
  ...Ge.classes,
  ...Ke.classes
};
ye.displayName = "@mantine/dates/Calendar";
function qe(e) {
  const {
    maxLevel: t,
    minLevel: s,
    defaultLevel: r,
    level: a,
    onLevelChange: n,
    nextIcon: p,
    previousIcon: c,
    date: o,
    defaultDate: u,
    onDateChange: d,
    numberOfColumns: _,
    columnsToScroll: b,
    ariaLabels: C,
    nextLabel: v,
    previousLabel: R,
    onYearSelect: j,
    onMonthSelect: F,
    onYearMouseEnter: N,
    onMonthMouseEnter: Y,
    onNextMonth: W,
    onPreviousMonth: m,
    onNextYear: L,
    onPreviousYear: A,
    onNextDecade: M,
    onPreviousDecade: x,
    withCellSpacing: O,
    highlightToday: $,
    __updateDateOnYearSelect: I,
    __updateDateOnMonthSelect: B,
    __setDateRef: g,
    __setLevelRef: f,
    withWeekNumbers: l,
    headerControlsOrder: h,
    // MonthLevelGroup props
    firstDayOfWeek: i,
    weekdayFormat: k,
    weekendDays: D,
    getDayProps: P,
    excludeDate: w,
    renderDay: H,
    hideOutsideDates: T,
    hideWeekdays: E,
    getDayAriaLabel: K,
    monthLabelFormat: Z,
    // YearLevelGroup props
    monthsListFormat: Q,
    getMonthControlProps: ee,
    yearLabelFormat: z,
    // DecadeLevelGroup props
    yearsListFormat: X,
    getYearControlProps: se,
    decadeLabelFormat: q,
    // External picker props
    allowSingleDateInRange: ae,
    allowDeselect: ne,
    // Other props
    minDate: G,
    maxDate: De,
    locale: Le,
    ...Qe
  } = e;
  return {
    calendarProps: {
      maxLevel: t,
      minLevel: s,
      defaultLevel: r,
      level: a,
      onLevelChange: n,
      nextIcon: p,
      previousIcon: c,
      date: o,
      defaultDate: u,
      onDateChange: d,
      numberOfColumns: _,
      columnsToScroll: b,
      ariaLabels: C,
      nextLabel: v,
      previousLabel: R,
      onYearSelect: j,
      onMonthSelect: F,
      onYearMouseEnter: N,
      onMonthMouseEnter: Y,
      onNextMonth: W,
      onPreviousMonth: m,
      onNextYear: L,
      onPreviousYear: A,
      onNextDecade: M,
      onPreviousDecade: x,
      withCellSpacing: O,
      highlightToday: $,
      __updateDateOnYearSelect: I,
      __updateDateOnMonthSelect: B,
      __setDateRef: g,
      withWeekNumbers: l,
      headerControlsOrder: h,
      // MonthLevelGroup props
      firstDayOfWeek: i,
      weekdayFormat: k,
      weekendDays: D,
      getDayProps: P,
      excludeDate: w,
      renderDay: H,
      hideOutsideDates: T,
      hideWeekdays: E,
      getDayAriaLabel: K,
      monthLabelFormat: Z,
      // YearLevelGroup props
      monthsListFormat: Q,
      getMonthControlProps: ee,
      yearLabelFormat: z,
      // DecadeLevelGroup props
      yearsListFormat: X,
      getYearControlProps: se,
      decadeLabelFormat: q,
      // External picker props
      allowSingleDateInRange: ae,
      allowDeselect: ne,
      // Other props
      minDate: G,
      maxDate: De,
      locale: Le
    },
    others: Qe
  };
}
function wt(e, t) {
  const s = [...t].sort((r, a) => y(r).isAfter(y(a)) ? 1 : -1);
  return y(s[0]).startOf("day").subtract(1, "ms").isBefore(e) && y(s[1]).endOf("day").add(1, "ms").isAfter(e);
}
function ht({
  type: e,
  level: t,
  value: s,
  defaultValue: r,
  onChange: a,
  allowSingleDateInRange: n,
  allowDeselect: p,
  onMouseLeave: c
}) {
  const [o, u] = mt({
    type: e,
    value: s,
    defaultValue: r,
    onChange: a
  }), [d, _] = Ae(
    e === "range" && o[0] && !o[1] ? o[0] : null
  ), [b, C] = Ae(null), v = (m) => {
    if (e === "range") {
      if (d && !o[1]) {
        if (y(m).isSame(d, t) && !n) {
          _(null), C(null), u([null, null]);
          return;
        }
        const L = [m, d];
        L.sort((A, M) => y(A).isAfter(y(M)) ? 1 : -1), u(L), C(null), _(null);
        return;
      }
      if (o[0] && !o[1] && y(m).isSame(o[0], t) && !n) {
        _(null), C(null), u([null, null]);
        return;
      }
      u([m, null]), C(null), _(m);
      return;
    }
    if (e === "multiple") {
      o.some((L) => y(L).isSame(m, t)) ? u(o.filter((L) => !y(L).isSame(m, t))) : u([...o, m]);
      return;
    }
    o && p && y(m).isSame(o, t) ? u(null) : u(m);
  }, R = (m) => d && b ? wt(m, [b, d]) : o[0] && o[1] ? wt(m, o) : !1, j = e === "range" ? (m) => {
    c?.(m), C(null);
  } : c, F = (m) => o[0] && y(m).isSame(o[0], t) ? !(b && y(b).isBefore(o[0])) : !1, N = (m) => o[1] ? y(m).isSame(o[1], t) : !o[0] || !b ? !1 : y(b).isBefore(o[0]) && y(m).isSame(o[0], t), Y = (m) => {
    if (e === "range")
      return {
        selected: o.some(
          (A) => A && y(A).isSame(m, t)
        ),
        inRange: R(m),
        firstInRange: F(m),
        lastInRange: N(m),
        "data-autofocus": !!o[0] && y(o[0]).isSame(m, t) || void 0
      };
    if (e === "multiple")
      return {
        selected: o.some(
          (A) => A && y(A).isSame(m, t)
        ),
        "data-autofocus": !!o[0] && y(o[0]).isSame(m, t) || void 0
      };
    const L = y(o).isSame(m, t);
    return { selected: L, "data-autofocus": L || void 0 };
  }, W = e === "range" && d ? C : () => {
  };
  return ct(() => {
    if (e === "range")
      if (o[0] && !o[1])
        _(o[0]);
      else {
        const m = o[0] == null && o[1] == null, L = o[0] != null && o[1] != null;
        (m || L) && (_(null), C(null));
      }
  }, [o]), {
    onDateChange: v,
    onRootMouseLeave: j,
    onHoveredDateChange: W,
    getControlProps: Y,
    _value: o,
    setValue: u
  };
}
const hr = {
  type: "default"
}, Ue = U((e, t) => {
  const s = J("YearPicker", hr, e), {
    classNames: r,
    styles: a,
    vars: n,
    type: p,
    defaultValue: c,
    value: o,
    onChange: u,
    __staticSelector: d,
    getYearControlProps: _,
    allowSingleDateInRange: b,
    allowDeselect: C,
    onMouseLeave: v,
    onYearSelect: R,
    __updateDateOnYearSelect: j,
    ...F
  } = s, { onDateChange: N, onRootMouseLeave: Y, onHoveredDateChange: W, getControlProps: m } = ht({
    type: p,
    level: "year",
    allowDeselect: C,
    allowSingleDateInRange: b,
    value: o,
    defaultValue: c,
    onChange: u,
    onMouseLeave: v
  }), { resolvedClassNames: L, resolvedStyles: A } = ue({
    classNames: r,
    styles: a,
    props: s
  });
  return /* @__PURE__ */ S.jsx(
    ye,
    {
      ref: t,
      minLevel: "decade",
      __updateDateOnYearSelect: j ?? !1,
      __staticSelector: d || "YearPicker",
      onMouseLeave: Y,
      onYearMouseEnter: (M, x) => W(x),
      onYearSelect: (M) => {
        N(M), R?.(M);
      },
      getYearControlProps: (M) => ({
        ...m(M),
        ..._?.(M)
      }),
      classNames: L,
      styles: A,
      ...F
    }
  );
});
Ue.classes = ye.classes;
Ue.displayName = "@mantine/dates/YearPicker";
const yr = {
  type: "default"
}, Je = U((e, t) => {
  const s = J("MonthPicker", yr, e), {
    classNames: r,
    styles: a,
    vars: n,
    type: p,
    defaultValue: c,
    value: o,
    onChange: u,
    __staticSelector: d,
    getMonthControlProps: _,
    allowSingleDateInRange: b,
    allowDeselect: C,
    onMouseLeave: v,
    onMonthSelect: R,
    __updateDateOnMonthSelect: j,
    onLevelChange: F,
    ...N
  } = s, { onDateChange: Y, onRootMouseLeave: W, onHoveredDateChange: m, getControlProps: L } = ht({
    type: p,
    level: "month",
    allowDeselect: C,
    allowSingleDateInRange: b,
    value: o,
    defaultValue: c,
    onChange: u,
    onMouseLeave: v
  }), { resolvedClassNames: A, resolvedStyles: M } = ue({
    classNames: r,
    styles: a,
    props: s
  });
  return /* @__PURE__ */ S.jsx(
    ye,
    {
      ref: t,
      minLevel: "year",
      __updateDateOnMonthSelect: j ?? !1,
      __staticSelector: d || "MonthPicker",
      onMouseLeave: W,
      onMonthMouseEnter: (x, O) => m(O),
      onMonthSelect: (x) => {
        Y(x), R?.(x);
      },
      getMonthControlProps: (x) => ({
        ...L(x),
        ..._?.(x)
      }),
      classNames: A,
      styles: M,
      onLevelChange: F,
      ...N
    }
  );
});
Je.classes = ye.classes;
Je.displayName = "@mantine/dates/MonthPicker";
var Dr = { datePickerRoot: "m_765a40cf", presetsList: "m_d6a681e1", presetButton: "m_acd30b22" };
const _r = Me((e, { size: t }) => ({
  datePickerRoot: {
    "--preset-font-size": we(t)
  }
})), vr = {
  type: "default",
  defaultLevel: "month",
  numberOfColumns: 1,
  size: "sm"
}, _e = U((e, t) => {
  const s = J("DatePicker", vr, e), {
    allowDeselect: r,
    allowSingleDateInRange: a,
    value: n,
    defaultValue: p,
    onChange: c,
    onMouseLeave: o,
    classNames: u,
    styles: d,
    __staticSelector: _,
    __onDayClick: b,
    __onDayMouseEnter: C,
    __onPresetSelect: v,
    __stopPropagation: R,
    presets: j,
    className: F,
    style: N,
    unstyled: Y,
    size: W,
    vars: m,
    attributes: L,
    ...A
  } = s, { calendarProps: M, others: x } = qe(A), O = fe(null), $ = fe(null), I = ce({
    name: _ || "DatePicker",
    classes: Dr,
    props: s,
    className: F,
    style: N,
    classNames: u,
    styles: d,
    unstyled: Y,
    attributes: L,
    rootSelector: j ? "datePickerRoot" : void 0,
    varsResolver: _r,
    vars: m
  }), { onDateChange: B, onRootMouseLeave: g, onHoveredDateChange: f, getControlProps: l, _value: h, setValue: i } = ht({
    type: x.type,
    level: "day",
    allowDeselect: r,
    allowSingleDateInRange: a,
    value: n,
    defaultValue: p,
    onChange: c,
    onMouseLeave: o
  }), { resolvedClassNames: k, resolvedStyles: D } = ue({
    classNames: u,
    styles: d,
    props: s
  }), P = /* @__PURE__ */ S.jsx(
    ye,
    {
      ref: t,
      classNames: k,
      styles: D,
      __staticSelector: _ || "DatePicker",
      onMouseLeave: g,
      size: W,
      ...M,
      ...j ? {} : x,
      __stopPropagation: R,
      __setDateRef: O,
      __setLevelRef: $,
      minLevel: M.minLevel || "month",
      __onDayMouseEnter: (T, E) => {
        f(E), C?.(T, E);
      },
      __onDayClick: (T, E) => {
        B(E), b?.(T, E);
      },
      getDayProps: (T) => ({
        ...l(T),
        ...M.getDayProps?.(T)
      }),
      getMonthControlProps: (T) => ({
        selected: typeof h == "string" ? pt(T, h) : !1,
        ...M.getMonthControlProps?.(T)
      }),
      getYearControlProps: (T) => ({
        selected: typeof h == "string" ? y(T).isSame(h, "year") : !1,
        ...M.getYearControlProps?.(T)
      }),
      hideOutsideDates: M.hideOutsideDates ?? M.numberOfColumns !== 1,
      ...j ? {} : { className: F, style: N, attributes: L }
    }
  );
  if (!j)
    return P;
  const w = (T) => {
    const E = Array.isArray(T) ? T[0] : T;
    E !== void 0 && (O.current?.(E), $.current?.("month"), v ? v(E) : i(T));
  }, H = j.map((T, E) => /* @__PURE__ */ S.jsx(
    be,
    {
      ...I("presetButton"),
      onClick: () => w(T.value),
      onMouseDown: (K) => K.preventDefault(),
      "data-mantine-stop-propagation": R || void 0,
      children: T.label
    },
    E
  ));
  return /* @__PURE__ */ S.jsxs(oe, { ...I("datePickerRoot"), size: W, ...x, children: [
    /* @__PURE__ */ S.jsx("div", { ...I("presetsList"), children: H }),
    P
  ] });
});
_e.classes = ye.classes;
_e.displayName = "@mantine/dates/DatePicker";
function yt({
  type: e,
  value: t,
  defaultValue: s,
  onChange: r,
  locale: a,
  format: n,
  closeOnChange: p,
  sortDates: c,
  labelSeparator: o,
  valueFormatter: u
}) {
  const d = de(), [_, b] = Ss(!1), [C, v] = mt({
    type: e,
    value: t,
    defaultValue: s,
    onChange: r
  }), R = At({
    type: e,
    date: C,
    locale: d.getLocale(a),
    format: n,
    labelSeparator: d.getLabelSeparator(o),
    formatter: u
  }), j = (Y) => {
    p && (e === "default" && b.close(), e === "range" && Y[0] && Y[1] && b.close()), v(c && e === "multiple" ? [...Y].sort((W, m) => y(W).isAfter(y(m)) ? 1 : -1) : Y);
  }, F = () => j(e === "range" ? [null, null] : e === "multiple" ? [] : null), N = e === "range" ? !!C[0] : e === "multiple" ? C.length > 0 : C !== null;
  return {
    _value: C,
    setValue: j,
    onClear: F,
    shouldClear: N,
    formattedValue: R,
    dropdownOpened: _,
    dropdownHandlers: b
  };
}
const gr = {
  type: "default",
  valueFormat: "YYYY",
  closeOnChange: !0,
  sortDates: !0,
  dropdownType: "popover"
}, ts = U(
  (e, t) => {
    const s = J("YearPickerInput", gr, e), {
      type: r,
      value: a,
      defaultValue: n,
      onChange: p,
      valueFormat: c,
      labelSeparator: o,
      locale: u,
      classNames: d,
      styles: _,
      unstyled: b,
      closeOnChange: C,
      size: v,
      variant: R,
      dropdownType: j,
      sortDates: F,
      minDate: N,
      maxDate: Y,
      vars: W,
      valueFormatter: m,
      attributes: L,
      ...A
    } = s, { resolvedClassNames: M, resolvedStyles: x } = ue({
      classNames: d,
      styles: _,
      props: s
    }), { calendarProps: O, others: $ } = qe(A), {
      _value: I,
      setValue: B,
      formattedValue: g,
      dropdownHandlers: f,
      dropdownOpened: l,
      onClear: h,
      shouldClear: i
    } = yt({
      type: r,
      value: a,
      defaultValue: n,
      onChange: p,
      locale: u,
      format: c,
      labelSeparator: o,
      closeOnChange: C,
      sortDates: F,
      valueFormatter: m
    });
    return /* @__PURE__ */ S.jsx(
      he,
      {
        formattedValue: g,
        dropdownOpened: l,
        dropdownHandlers: f,
        classNames: M,
        styles: x,
        unstyled: b,
        ref: t,
        onClear: h,
        shouldClear: i,
        value: I,
        size: v,
        variant: R,
        dropdownType: j,
        ...$,
        type: r,
        __staticSelector: "YearPickerInput",
        attributes: L,
        children: /* @__PURE__ */ S.jsx(
          Ue,
          {
            ...O,
            size: v,
            variant: R,
            type: r,
            value: I,
            defaultDate: O.defaultDate || (Array.isArray(I) ? I[0] || Ye({ maxDate: Y, minDate: N }) : I || Ye({ maxDate: Y, minDate: N })),
            onChange: B,
            locale: u,
            classNames: M,
            styles: x,
            unstyled: b,
            __staticSelector: "YearPickerInput",
            __stopPropagation: j === "popover",
            minDate: N,
            maxDate: Y,
            attributes: L
          }
        )
      }
    );
  }
);
ts.classes = { ...he.classes, ...Ue.classes };
ts.displayName = "@mantine/dates/YearPickerInput";
const br = {
  type: "default",
  valueFormat: "MMMM YYYY",
  closeOnChange: !0,
  sortDates: !0,
  dropdownType: "popover"
}, ss = U(
  (e, t) => {
    const s = J("MonthPickerInput", br, e), {
      type: r,
      value: a,
      defaultValue: n,
      onChange: p,
      valueFormat: c,
      labelSeparator: o,
      locale: u,
      classNames: d,
      styles: _,
      unstyled: b,
      closeOnChange: C,
      size: v,
      variant: R,
      dropdownType: j,
      sortDates: F,
      minDate: N,
      maxDate: Y,
      vars: W,
      valueFormatter: m,
      attributes: L,
      ...A
    } = s, { resolvedClassNames: M, resolvedStyles: x } = ue({
      classNames: d,
      styles: _,
      props: s
    }), { calendarProps: O, others: $ } = qe(A), {
      _value: I,
      setValue: B,
      formattedValue: g,
      dropdownHandlers: f,
      dropdownOpened: l,
      onClear: h,
      shouldClear: i
    } = yt({
      type: r,
      value: a,
      defaultValue: n,
      onChange: p,
      locale: u,
      format: c,
      labelSeparator: o,
      closeOnChange: C,
      sortDates: F,
      valueFormatter: m
    });
    return /* @__PURE__ */ S.jsx(
      he,
      {
        formattedValue: g,
        dropdownOpened: l,
        dropdownHandlers: f,
        classNames: M,
        styles: x,
        unstyled: b,
        ref: t,
        onClear: h,
        shouldClear: i,
        value: I,
        size: v,
        variant: R,
        dropdownType: j,
        ...$,
        attributes: L,
        type: r,
        __staticSelector: "MonthPickerInput",
        children: /* @__PURE__ */ S.jsx(
          Je,
          {
            ...O,
            size: v,
            variant: R,
            type: r,
            value: I,
            defaultDate: O.defaultDate || (Array.isArray(I) ? I[0] || Ye({ maxDate: Y, minDate: N }) : I || Ye({ maxDate: Y, minDate: N })),
            onChange: B,
            locale: u,
            classNames: M,
            styles: x,
            unstyled: b,
            __staticSelector: "MonthPickerInput",
            __stopPropagation: j === "popover",
            minDate: N,
            maxDate: Y,
            attributes: L
          }
        )
      }
    );
  }
);
ss.classes = { ...he.classes, ...Je.classes };
ss.displayName = "@mantine/dates/MonthPickerInput";
const Cr = {
  type: "default",
  valueFormat: "MMMM D, YYYY",
  closeOnChange: !0,
  sortDates: !0,
  dropdownType: "popover"
}, Ze = U(
  (e, t) => {
    const s = J("DatePickerInput", Cr, e), {
      type: r,
      value: a,
      defaultValue: n,
      onChange: p,
      valueFormat: c,
      labelSeparator: o,
      locale: u,
      classNames: d,
      styles: _,
      unstyled: b,
      closeOnChange: C,
      size: v,
      variant: R,
      dropdownType: j,
      sortDates: F,
      minDate: N,
      maxDate: Y,
      vars: W,
      defaultDate: m,
      valueFormatter: L,
      presets: A,
      attributes: M,
      ...x
    } = s, { resolvedClassNames: O, resolvedStyles: $ } = ue({
      classNames: d,
      styles: _,
      props: s
    }), { calendarProps: I, others: B } = qe(x), {
      _value: g,
      setValue: f,
      formattedValue: l,
      dropdownHandlers: h,
      dropdownOpened: i,
      onClear: k,
      shouldClear: D
    } = yt({
      type: r,
      value: a,
      defaultValue: n,
      onChange: p,
      locale: u,
      format: c,
      labelSeparator: o,
      closeOnChange: C,
      sortDates: F,
      valueFormatter: L
    }), P = Array.isArray(g) ? g[0] || m : g || m;
    return /* @__PURE__ */ S.jsx(
      he,
      {
        formattedValue: l,
        dropdownOpened: i,
        dropdownHandlers: h,
        classNames: O,
        styles: $,
        unstyled: b,
        ref: t,
        onClear: k,
        shouldClear: D,
        value: g,
        size: v,
        variant: R,
        dropdownType: j,
        ...B,
        type: r,
        __staticSelector: "DatePickerInput",
        attributes: M,
        children: /* @__PURE__ */ S.jsx(
          _e,
          {
            ...I,
            size: v,
            variant: R,
            type: r,
            value: g,
            defaultDate: P || Ye({ maxDate: Y, minDate: N }),
            onChange: f,
            locale: u,
            classNames: O,
            styles: $,
            unstyled: b,
            __staticSelector: "DatePickerInput",
            __stopPropagation: j === "popover",
            minDate: N,
            maxDate: Y,
            presets: A,
            attributes: M
          }
        )
      }
    );
  }
);
Ze.classes = { ...he.classes, ..._e.classes };
Ze.displayName = "@mantine/dates/DatePickerInput";
const je = (e) => e ? e.toISOString().split("T")[0] : null, Re = (e) => {
  if (!e) return null;
  const t = new Date(e);
  return isNaN(t.getTime()) ? null : t;
}, Mr = (e) => {
  if (Array.isArray(e)) {
    const t = e[0] instanceof Date ? e[0] : Re(e[0]), s = e[1] instanceof Date ? e[1] : Re(e[1]);
    return [t, s];
  }
  return [null, null];
}, Lr = (e) => e instanceof Date ? e : typeof e == "string" ? Re(e) : null, Sr = (e) => e instanceof Date ? e : typeof e == "string" ? Re(e) : Array.isArray(e) && e[0] ? Lr(e[0]) : null, kr = (e) => Array.isArray(e) ? [je(e[0]), je(e[1])] : [null, null], Yr = (e) => e instanceof Date ? je(e) : Array.isArray(e) && e[0] instanceof Date ? je(e[0]) : null, Ur = ({
  label: e = "Pick a date",
  value: t,
  onChange: s,
  type: r = "default",
  buttonProps: a,
  locale: n,
  labelSeparator: p,
  valueFormatter: c,
  format: o,
  clearable: u,
  ...d
}) => {
  const _ = de(), [b, C] = Ae(!1), v = fe(b), [R, j] = Ae(
    r === "range" ? [null, null] : null
  );
  ct(() => {
    if (v.current && !b && r === "range") {
      const M = t !== void 0 ? t : R;
      Array.isArray(M) && (M[0] && !M[1] || !M[0] && M[1]) && (j([null, null]), s && s([null, null]));
    }
    v.current = b;
  }, [b]);
  const F = t !== void 0 ? t : R, N = r === "range" ? kr(F) : Yr(F), Y = (M, x) => M !== "range" || Array.isArray(x) && !!x[0] && !!x[1], W = (M) => {
    const x = r === "range" ? Mr(M) : Sr(M);
    s && s(x), j(x), Y(r, x) && C(!1);
  }, m = (M) => {
    M.stopPropagation();
    const x = r === "range" ? [null, null] : null;
    j(x), s && s(x);
  };
  let L = e;
  if (r === "range" && Array.isArray(F)) {
    const [M, x] = F;
    M && x ? L = `${M.toLocaleDateString()} - ${x.toLocaleDateString()}` : M ? L = `${M.toLocaleDateString()} - ...` : x && (L = `... - ${x.toLocaleDateString()}`);
  } else F instanceof Date && (L = F.toLocaleDateString());
  const A = At({
    type: r,
    date: N,
    locale: _.getLocale(n),
    format: o || "",
    labelSeparator: _.getLabelSeparator(p),
    formatter: c
  });
  return /* @__PURE__ */ S.jsxs(
    Ce,
    {
      opened: b,
      onChange: C,
      position: "bottom-start",
      classNames: {
        dropdown: "!p-6 !rounded-lg"
      },
      children: [
        /* @__PURE__ */ S.jsx(Ce.Target, { children: /* @__PURE__ */ S.jsxs(
          Ms,
          {
            onClick: () => C((M) => !M),
            classNames: {
              ...a?.classNames,
              label: "block flex items-center"
            },
            ...a,
            children: [
              A || L,
              A && u && /* @__PURE__ */ S.jsx(ks, { className: "ml-1", size: "14px", onClick: m })
            ]
          }
        ) }),
        /* @__PURE__ */ S.jsx(Ce.Dropdown, { children: r === "range" ? /* @__PURE__ */ S.jsx(
          _e,
          {
            type: "range",
            value: N,
            onChange: W,
            ...d
          }
        ) : /* @__PURE__ */ S.jsx(
          _e,
          {
            type: "default",
            value: N,
            onChange: W,
            ...d
          }
        ) })
      ]
    }
  );
}, Jr = bs(
  ({ size: e = "sm", pickerSize: t = "sm", ...s }, r) => /* @__PURE__ */ S.jsx(
    Ze,
    {
      ref: r,
      size: e,
      getDayProps: () => ({
        size: t
      }),
      getMonthControlProps: () => ({
        size: t
      }),
      getYearControlProps: () => ({
        size: t
      }),
      ...s
    }
  )
), wr = "_calendarHeader_gzbqc_1", xr = "_calendarHeaderLevel_gzbqc_9", Pr = "_calendarHeaderControlIcon_gzbqc_14", Nr = "_monthsListControl_gzbqc_19", $r = "_yearsListControl_gzbqc_23", Or = "_monthRow_gzbqc_27", Ar = "_monthCell_gzbqc_32", jr = "_day_gzbqc_51", Rr = "_weekdaysRow_gzbqc_91", Fr = "_weekday_gzbqc_91", Tr = "_monthTbody_gzbqc_103", xt = {
  calendarHeader: wr,
  calendarHeaderLevel: xr,
  calendarHeaderControlIcon: Pr,
  monthsListControl: Nr,
  yearsListControl: $r,
  monthRow: Or,
  monthCell: Ar,
  day: jr,
  weekdaysRow: Rr,
  weekday: Fr,
  monthTbody: Tr
}, Zr = Ls({
  components: {
    DatePicker: _e.extend({
      classNames: xt
    }),
    DatePickerInput: Ze.extend({
      classNames: xt,
      defaultProps: {
        size: "md",
        radius: "md",
        inputWrapperOrder: ["label", "input", "description", "error"],
        popoverProps: {
          classNames: {
            dropdown: "!p-6 !rounded-lg"
          }
        }
      }
    })
  }
});
export {
  ye as Calendar,
  Zr as DATES_THEME,
  _e as DatePicker,
  Ur as DatePickerButton,
  Jr as DatePickerInput,
  qr as DatesProvider,
  ss as MonthPickerInput,
  Ht as TimeInput,
  ts as YearPickerInput
};
